import { useInfiniteQuery, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Checkbox, Form, FormInstance, Image, Input, Modal, Popover, Radio, Spin } from 'antd';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { assetsApi, storageItemApi, storageItemNotesApi, storageProcessApi } from '../../../../apis';
import { photoRequestApi } from '../../../../apis/photoRequest';
import { cancelRefundNote, useCancellationRate } from '../../../../util/cancelFee';
import {
  AddOversizeFeeDto,
  CancelShipToBuyerDto,
  CancelStorageRequest,
  CreateSpecialHandlingFeeDto,
  StorageExtraFeePayment,
  CreateStorageItemNoteDto,
  DeleteAssetDtoTypeEnum,
  StorageItem,
  StorageItemNote,
  TakePhotoRequest,
  UpdateDisposalRequestDto,
  UpdateStorageItemNoteDto,
  UpdateTrackingNumber,
  UploadRealVolumeDto,
  UploadStaffCommentDto,
  UploadStorageVolumeDto,
} from '../../../../apis/client-axios';
import SvgCloseModalIcon from '../../../../components/@svg/SvgCloseModalIcon';
import ButtonAgree from '../../../../components/buttonCustom/ButtonAgree';
import ButtonCancel from '../../../../components/buttonCustom/ButtonCancel';
import { CustomCommonButton } from '../../../../components/buttons/common/CustomButton';
import FormWrap from '../../../../components/FormWrap';
import CustomInputArea from '../../../../components/input/CustomTextArea';
import VideoModal from '../../../../components/modals/videoModal';
import NotificationSuccess from '../../../../components/notifications/NotificationSuccess';
import ViewStatus from '../../../../components/ViewStatus';
import { RootState } from '../../../../store';
import {
  AdminRole,
  ERROR_REASON_JP,
  QUERY_KEY,
  REQUEST_ACTION_ITEM_DETAIL,
  STATUS_ITEM_MANAGEMENT,
  TAKE_PHOTO_REQUEST_STATUS,
  TIME_FORMAT,
} from '../../../../util/constants';
import { Helper, renderStatus } from '../../../../util/helper';
import { printSKU } from '../../../../util/print';
import { ChatItem } from '../chatItem';
import TakePhotoModal from '../modals/takePhotoModal';
import UploadMedia from '../UploadFiles/uploadMedia';
import './index.scss';
import NotificationError from '../../../../components/notifications/NotificationError';
import { SvgDolarIcon } from '../../../../components/@svg/SvgDolarIcon';
import _, { max } from 'lodash';
import SvgWarningIcon from '../../../../components/@svg/SvgWarningIcon';
import TextArea from 'antd/es/input/TextArea';
import SvgIconEditLarge from '../../../../components/@svg/SvgEditLarge';
import CustomConfirmModel from '../../../../components/modals/confirmModel';
import { decode as decodeHtml } from 'he';
import RowDetail from './components/RowDetail';
import {
  AmericaTimezone,
  countDecimalPlaces,
  getLinkItemEbayNavigate,
  resizeImageItemEbay,
  sortByParenIndex,
} from '../../../../util/function-util';
import { SvgIconX } from './components/@svg/SvgIconX';
import SvgIconCheck from './components/@svg/SvgCheck';
import { SvgPencil } from './components/@svg/SvgPenceil';
import { useInView } from 'react-intersection-observer';
import { MoreSvg } from './@svg/more';
import { PenSvg } from './@svg/edit';
import { TrashSvg } from './@svg/trash';
import ModalConfirm from './components/ModalConfirm';
import { PrintIcon } from './components/@svg/PrintIcon';
import { DimensionRow } from './components/DimensionRow';
import { QuarterInchInput } from './components/QuarterInchInput';
import { InchDisplay } from './components/InchDisplay';
import { cmToInchParts } from './helper';
import SvgIconEdit from '../../../../components/@svg/SvgIconEdit';
import CustomInput from '../../../../components/input/CustomInput';
import { RequestManagementQuarterInchInput } from '../../requestManagement';

type SpecialFeeItem = {
  id: number;
  title: string;
  chargeAmount: number;
  isProfit: boolean;
};

type SpecialFeeForm = {
  title: string;
  chargeAmount: string;
  isProfit: boolean;
};

const EMPTY_SPECIAL_FEE_FORM: SpecialFeeForm = { title: '', chargeAmount: '', isProfit: true };

type SpecialFeeError = { title: boolean; chargeAmount: boolean };

const EMPTY_SPECIAL_FEE_ERROR: SpecialFeeError = { title: false, chargeAmount: false };

const SPECIAL_HANDLING_FEE_TYPE = 'special_handling';
// Task 2 — 3 loại phụ phí oversize gom chung 1 dòng 規格外貨物追加送料 (giống màn user).
const OVERSIZE_FEE_TYPES = ['oversize_long_item', 'oversize_deformed', 'oversize_non_carton'];
const OVERSIZE_FEE_TITLE = '規格外貨物追加送料';

type OversizeFlag = 'isDeformed' | 'isNonCarton';

const ItemDetail = () => {
  const arrStatusInputMeasure = [
    STATUS_ITEM_MANAGEMENT.IN_TRANSIT,
    STATUS_ITEM_MANAGEMENT.DELIVERED,
    STATUS_ITEM_MANAGEMENT.NOT_SHIPPED,
    STATUS_ITEM_MANAGEMENT.TEMPORARY_CANCELED,
    STATUS_ITEM_MANAGEMENT.WAITING_UPLOAD_IMAGE_VIDEO,
    STATUS_ITEM_MANAGEMENT.IN_STORAGE_HAS_CHECK_FLAG,
  ];

  const { id } = useParams();
  const { authUser } = useSelector((state: RootState) => state.auth);
  const navigate = useNavigate();
  const intl = useIntl();
  const queryClient = useQueryClient();

  const [formUploadByStatus] = Form.useForm<FormInstance>();
  const [isLoadingUpload, setIsLoadingUpload] = useState<boolean>(false);
  const [isLoadingUploadMedia, setIsLoadingUploadMedia] = useState<boolean>(false);
  const [activeModalCancel, setActiveModalCancel] = useState(false);
  const [activeAddPhoto, setActiveAddPhoto] = useState<{ isShow: boolean; takePhotoRequest: TakePhotoRequest }>({
    isShow: false,
    takePhotoRequest: null,
  });
  const [activeModalCancelRequest, setActiveModalCancelRequest] = useState({ isShow: false, action: null });
  const [activeModalRevert, setActiveModalRevert] = useState(false);

  const [statusUploadFiles, setStatusUploadFiles] = useState<{ isShow: boolean; takePhotoRequest: TakePhotoRequest }>({
    isShow: false,
    takePhotoRequest: null,
  });
  const [activeRegisterNote, setActiveRegisterNote] = useState(false);
  const [lstNote, setLstNote] = useState<StorageItemNote[]>([]);
  const [noteDetail, setNoteDetail] = useState<StorageItemNote>();
  const [itemDetailRealVol, setItemDetailRealVol] = useState<UploadRealVolumeDto>({
    realLength: undefined,
    realHeight: undefined,
    realWeight: undefined,
    realWidth: undefined,
    isDeformed: false,
    isNonCarton: false,
    storageItemId: 0,
  });
  const [itemDetailStorageVol, setItemDetailStorageVol] = useState<UploadStorageVolumeDto>({
    storageLength: undefined,
    storageHeight: undefined,
    storageWeight: undefined,
    storageWidth: undefined,
    storageItemId: 0,
  });
  const [realError, setRealError] = useState({
    length: false,
    width: false,
    height: false,
    weight: false,
  });

  const [storageError, setStorageError] = useState({
    length: false,
    width: false,
    height: false,
    weight: false,
  });

  const [focusComment, setFocusComment] = useState<{ open: boolean; staffComment: string }>({
    open: false,
    staffComment: '',
  });
  const [removePhoto, setRemovePhoto] = useState<{ open: boolean; id: string | number } | undefined>(undefined);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenConfirm, setIsOpenConfirm] = useState(false);
  const [isOpenDisposalDims, setIsOpenDisposalDims] = useState(false);
  const [disposalDims, setDisposalDims] = useState<{
    length?: number;
    width?: number;
    height?: number;
    weight?: number;
  }>({});
  const [disposalDimsError, setDisposalDimsError] = useState({
    length: false,
    width: false,
    height: false,
    weight: false,
  });
  const [disposalWeightInput, setDisposalWeightInput] = useState('');
  const [isOpenCheck, setIsOpenCheck] = useState(false);
  const [itemDetail, setItemDetail] = useState<StorageItem>(undefined);
  const [visibleSender, setVisibleSender] = useState(false);
  const [previewSender, setPreviewSender] = useState<{ source: string; index: number } | undefined>(undefined);
  const [isOpenNotifyUpload, setIsOpenNotifyUpload] = useState(false);
  const [form] = Form.useForm<FormInstance>();
  const [formUpdateItem] = Form.useForm<FormInstance>();
  const [activePopup, setActivePopup] = useState(null);
  const [actionEditTrackingNumber, setActionEditTrackingNumber] = useState(false);
  const popupRef = useRef(null);
  const [formTrackingNumber] = Form.useForm();
  const [refNote, inViewNote] = useInView({ threshold: 0 });
  const [menuNote, setMenuNote] = useState<{ id: number; isOpenMenu: boolean }>({
    id: 0,
    isOpenMenu: false,
  });
  const [expandBox, setExpandBox] = useState(false);
  const [isEdit, setIsEdit] = useState({ id: null, isOpen: false, content: '', data: undefined });
  const [openModalNoteDelete, setOpenModalNoteDelete] = useState<{ id: number; isOpen: boolean }>({
    id: undefined,
    isOpen: false,
  });
  const [loadingPrintSku, setLoadingPrintSku] = useState(false);
  const [isEditItemInfo, setIsEditItemInfo] = useState(false);
  const [itemInfoDraft, setItemInfoDraft] = useState({
    internalSku: '',
    itemSku: '',
    itemName: '',
  });

  const hasItemInfoChanged = useMemo(() => {
    if (!itemDetail) return false;

    const original = {
      internalSku: (itemDetail.internalSku ?? '').trim(),
      itemSku: (itemDetail.itemSku ?? '').trim(),
      itemName: decodeHtml(itemDetail.itemName || '').trim(),
    };

    const draft = {
      internalSku: (itemInfoDraft.internalSku ?? '').trim(),
      itemSku: (itemInfoDraft.itemSku ?? '').trim(),
      itemName: (itemInfoDraft.itemName ?? '').trim(),
    };

    return (
      original.internalSku !== draft.internalSku ||
      original.itemSku !== draft.itemSku ||
      original.itemName !== draft.itemName
    );
  }, [itemDetail, itemInfoDraft]);

  const updateItemInfoMutation = useMutation({
    mutationFn: (dto: {
      storageItemId: number;
      itemInformation: {
        internalSku: string;
        itemSku: string;
        itemName: string;
      };
    }) => storageItemApi.storageItemControllerUpdateItemInformation(dto),

    onSuccess: (_, variables) => {
      queryClient.setQueryData([QUERY_KEY.ITEM_DETAIL, id], (old: any) => {
        if (!old?.data) return old;

        return {
          ...old,
          data: {
            ...old.data,
            internalSku: variables.itemInformation.internalSku,
            itemSku: variables.itemInformation.itemSku,
            itemName: variables.itemInformation.itemName,
          },
        };
      });

      setItemDetail((prev) =>
        prev
          ? {
              ...prev,
              internalSku: variables.itemInformation.internalSku,
              itemSku: variables.itemInformation.itemSku,
              itemName: variables.itemInformation.itemName,
            }
          : prev,
      );

      setIsEditItemInfo(false);
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.updateSuccess' }) });

      onRefetchItems();
    },
    onError: (error: any) => {
      const msgError: string = error?.response?.data?.message ?? '';
      if (msgError.includes('INTERNAL_SKU_ERROR')) {
        NotificationError({ content: ERROR_REASON_JP.BAYPACK_NUMBER_ERROR });
      }
    },
  });

  const [openSpecialFeeModal, setOpenSpecialFeeModal] = useState(false);
  const [specialFeeForm, setSpecialFeeForm] = useState<SpecialFeeForm>(EMPTY_SPECIAL_FEE_FORM);
  const [specialFeeError, setSpecialFeeError] = useState(EMPTY_SPECIAL_FEE_ERROR);

  const addSpecialHandlingFee = useMutation({
    mutationFn: (dto: CreateSpecialHandlingFeeDto) => storageItemApi.storageItemControllerAddSpecialHandlingFee(dto),
  });

  const specialFeeList = useMemo<SpecialFeeItem[]>(() => {
    const extraFees: StorageExtraFeePayment[] =
      itemDetail?.storageExtraFeePayment ?? (itemDetail as any)?.specialHandlingFees ?? [];
    return extraFees
      .filter((fee) => fee.type === SPECIAL_HANDLING_FEE_TYPE)
      .map((fee) => ({
        id: fee.id,
        title: fee.customTitle ?? '',
        chargeAmount: Number(fee.chargeAmount ?? 0),
        isProfit: !!fee.isProfit,
      }));
  }, [itemDetail?.storageExtraFeePayment, (itemDetail as any)?.specialHandlingFees]);

  // 特別配送費用 = 規格外貨物追加送料: long-item thu lúc tạo request (cấp request, chia N商品)
  // + phí oversize thu lúc kiểm hàng (cấp item). Hai đường long-item loại trừ nhau (cờ isOversizeLongItem).
  // Không gộp phí nhập tay 粗利対象外 như màn user vì CMS đã liệt kê chúng ở mục 追加手数料.
  const requestOversizeFee = Number((itemDetail?.storageRequest as any)?.oversizeLongItemFee || 0);
  const oversizeFeeTotal = useMemo(() => {
    const extraFees: StorageExtraFeePayment[] =
      itemDetail?.storageExtraFeePayment ?? (itemDetail as any)?.specialHandlingFees ?? [];
    const inspectionOversizeFee = extraFees
      .filter((fee) => OVERSIZE_FEE_TYPES.includes(fee.type))
      .reduce((total, fee) => total + Number(fee.chargeAmount || 0), 0);
    return requestOversizeFee + inspectionOversizeFee;
  }, [itemDetail, requestOversizeFee]);

  // Gọi trong JSX (lúc render) nên dùng được handleButtonClick khai báo phía dưới.
  const renderOversizeFeeItem = () => {
    const itemCount = itemDetail?.storageRequest?.storageItems?.length ?? 0;
    // Hậu tố /N商品 chỉ khi có phần phí cấp request (thu 1 lần cho cả đơn).
    const suffix = requestOversizeFee > 0 && itemCount > 1 ? `/${itemCount}商品` : '';
    return (
      <div className="item-detail_content_info-product_table_right_row_item">
        <div className="item-detail_content_info-product_table_right_row_left">
          <div className="item-detail_content_info-product_table_right_row_left_text">
            特別配送費用
            <div className="item-detail_content_info-product_table_right_row_left_text_des">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                className="item-detail_content_info-product_table_right_row_left_text_des_button"
                onClick={() => handleButtonClick(3)}
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.41667 12.0927L7.37933 8H5.95833V6.83333H8.7595L8.7945 10.926H10.1V12.0927H7.41667ZM7.125 4.857C7.11665 4.61002 7.20305 4.36919 7.3665 4.18383C7.52672 4.00494 7.75617 3.91589 8.05483 3.91667C8.3535 3.91667 8.5845 4.00611 8.74783 4.185C8.91117 4.36311 8.99244 4.58711 8.99167 4.857C8.99167 5.123 8.91 5.34389 8.74667 5.51967C8.58333 5.69544 8.35272 5.78333 8.05483 5.78333C7.75694 5.78333 7.5275 5.69544 7.3665 5.51967C7.20243 5.33887 7.11573 5.10097 7.125 4.857ZM8 13.8333C9.5471 13.8333 11.0308 13.2188 12.1248 12.1248C13.2188 11.0308 13.8333 9.5471 13.8333 8C13.8333 6.4529 13.2188 4.96917 12.1248 3.87521C11.0308 2.78125 9.5471 2.16667 8 2.16667C6.4529 2.16667 4.96917 2.78125 3.87521 3.87521C2.78125 4.96917 2.16667 6.4529 2.16667 8C2.16667 9.5471 2.78125 11.0308 3.87521 12.1248C4.96917 13.2188 6.4529 13.8333 8 13.8333ZM8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.8295 1 8.91925 1 8C1 7.08075 1.18106 6.1705 1.53284 5.32122C1.88463 4.47194 2.40024 3.70026 3.05025 3.05025C3.70026 2.40024 4.47194 1.88463 5.32122 1.53284C6.1705 1.18106 7.08075 1 8 1C9.85651 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85651 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85651 15 8 15Z"
                  fill="#514B4D"
                />
              </svg>
              <div
                ref={popupRef}
                className={`popup-content item-detail_content_info-product_table_right_row_left_text_des_popup ${
                  activePopup === 3 ? 'show' : ''
                }`}
              >
                <div className="item-detail_fee-breakdown_title">特別配送費用　内訳</div>
                <div className="item-detail_fee-breakdown_line">
                  <span>{OVERSIZE_FEE_TITLE}</span>
                  <span>:</span>
                  <span>{oversizeFeeTotal.toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>
          <span>:</span>
        </div>
        <div className="item-detail_content_info-product_table_right_row_right">
          {`$${oversizeFeeTotal.toFixed(2)}${suffix}`}
        </div>
      </div>
    );
  };

  const handleOpenSpecialFeeModal = () => {
    setSpecialFeeForm(EMPTY_SPECIAL_FEE_FORM);
    setSpecialFeeError(EMPTY_SPECIAL_FEE_ERROR);
    setOpenSpecialFeeModal(true);
  };

  const handleCloseSpecialFeeModal = () => {
    setOpenSpecialFeeModal(false);
    setSpecialFeeForm(EMPTY_SPECIAL_FEE_FORM);
    setSpecialFeeError(EMPTY_SPECIAL_FEE_ERROR);
  };

  const handleSubmitSpecialFee = async () => {
    if (!itemDetail?.id || addSpecialHandlingFee.isPending) return;

    const title = specialFeeForm.title.trim();
    const rawChargeAmount = specialFeeForm.chargeAmount.trim();
    const chargeAmount = Number(rawChargeAmount);

    const nextError: SpecialFeeError = {
      title: !title,
      chargeAmount: !rawChargeAmount || !Number.isFinite(chargeAmount) || chargeAmount <= 0,
    };
    setSpecialFeeError(nextError);

    if (nextError.title || nextError.chargeAmount) return;

    try {
      await addSpecialHandlingFee.mutateAsync({
        storageItemId: itemDetail.id,
        title,
        chargeAmount,
        isProfit: specialFeeForm.isProfit,
      });
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.createSuccess' }) });
      handleCloseSpecialFeeModal();
      onRefetchItems();
    } catch (error) {
      NotificationError({ content: '登録に失敗しました。' });
    }
  };

  // Khối 追加手数料 (Task 5 & 6 — phí xử lý / phí phát sinh admin nhập tự do).
  // Dùng chung cho view admin/staff và view OP — OP chỉ nhận riêng khối này,
  // các dòng giá khác của 料金情報 vẫn ẩn như cũ.
  const renderSpecialFeeSection = (
    <div className="item-detail_special-fee">
      <div className="title item-detail_special-fee_header">
        <span>追加手数料</span>
        <button type="button" className="item-detail_special-fee_add" onClick={handleOpenSpecialFeeModal}>
          {intl.formatMessage({ id: 'common.add' })}
        </button>
      </div>

      {specialFeeList.map((fee) => (
        <RowDetail
          key={fee.id}
          label={fee.title}
          value={
            <>
              <span>${fee.chargeAmount.toFixed(2)}</span>
              <span className={`item-detail_special-fee_tag ${fee.isProfit ? 'is-profit' : 'is-not-profit'}`}>
                {fee.isProfit ? '粗利対象' : '粗利対象外'}
              </span>
            </>
          }
        />
      ))}
    </div>
  );

  const [oversizeConfirm, setOversizeConfirm] = useState<OversizeFlag | null>(null);

  const isRealDimRegistered = !!itemDetail?.storageRequest?.realLength;

  const addOversizeFee = useMutation({
    mutationFn: (dto: AddOversizeFeeDto) => storageProcessApi.storageProcessControllerAddOversizeFeeAfterCheck(dto),
    onSuccess: () => {
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.updateSuccess' }) });
      setOversizeConfirm(null);
      onRefetchItems();
    },
    onError: () => {
      NotificationError({ content: '登録に失敗しました。' });
      setOversizeConfirm(null);
    },
  });

  // Chỉ khoá khi cờ đã thực sự lưu ở backend (storageRequest) hoặc đang gọi API thu phí.
  // Khi chưa nhập kích thước, approve chỉ set cờ local (chưa gọi API) -> vẫn cho uncheck cho tới khi
  // được lưu cùng size (uploadRealVolume) hoặc lưu riêng (addOversizeFee).
  const isOversizeFlagDisabled = (flag: OversizeFlag) =>
    !!itemDetail?.storageRequest?.[flag] || addOversizeFee.isPending;

  const handleToggleOversizeFlag = (flag: OversizeFlag, checked: boolean) => {
    if (!checked) {
      setItemDetailRealVol((prev) => ({ ...prev, [flag]: false }));
      return;
    }
    setOversizeConfirm(flag);
  };

  const handleApproveOversizeFee = () => {
    if (!oversizeConfirm || !itemDetail?.id) return;

    if (!isRealDimRegistered) {
      setItemDetailRealVol((prev) => ({ ...prev, [oversizeConfirm]: true }));
      setOversizeConfirm(null);
      return;
    }

    addOversizeFee.mutate({
      storageItemId: itemDetail.id,
      isDeformed: oversizeConfirm === 'isDeformed',
      isNonCarton: oversizeConfirm === 'isNonCarton',
    });
  };

  const statusItem: string = renderStatus(itemDetail);
  const {
    data: listNote,
    refetch,
    fetchNextPage,
  } = useInfiniteQuery({
    queryKey: [QUERY_KEY.LIST_NOTE],
    queryFn: ({ pageParam }) => storageItemNotesApi.storageItemNoteControllerFindAllByItemStorageId(id, pageParam, 20),
    initialPageParam: 1,
    enabled: !!id,
    getNextPageParam: (_, __, page) => page + 1,
  });
  const [editDimensionStorage, setEditDimensionStorage] = useState(false);

  const editDimensionStorageApi = useMutation({
    mutationKey: ['EDIT_DIMENSION_STORAGE'],
    mutationFn: (uploadStorageVolumeDto: UploadStorageVolumeDto) =>
      storageProcessApi.storageProcessControllerEditStorageVolume(uploadStorageVolumeDto),
    onSuccess: () => {
      onRefetchItems();
      onCancelEditDimensionStorage();
    },
  });

  const { mutate: AssetMutation } = useMutation({
    mutationFn: (id: string) => assetsApi.assetControllerDelete(id, { type: DeleteAssetDtoTypeEnum.Hard }),
    onSuccess: ({ data }) => {
      onRefetchItems();
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.updateSuccess' }) });
    },
  });

  const onSubmitEditDimensionStorage = () => {
    const payload = { ...itemDetailStorageVol };

    const numericValues = [
      payload.storageLength,
      payload.storageWidth,
      payload.storageHeight,
      payload.storageWeight,
    ].filter((v) => typeof v === 'number') as number[];

    if (numericValues.length === 0 || numericValues.some((val) => val == null || !Number.isFinite(val) || val <= 0)) {
      NotificationError({ content: '整数を入力してください。' });
      return;
    }

    if (
      payload.storageWeight != null &&
      Number.isFinite(payload.storageWeight) &&
      countDecimalPlaces(payload.storageWeight) > 2
    ) {
      NotificationError({ content: '小数点以下は2桁まで入力してください。' });
      return;
    }

    editDimensionStorageApi.mutate(payload);
  };

  const onCancelEditDimensionStorage = () => {
    if (!itemDetail) {
      setEditDimensionStorage(false);
      return;
    }

    setItemDetailStorageVol((prev) => ({
      ...prev,
      storageHeight: itemDetail.storageHeight ?? undefined,
      storageWeight: itemDetail.storageWeight ?? undefined,
      storageWidth: itemDetail.storageWidth ?? undefined,
      storageLength: itemDetail.storageLength ?? undefined,
      storageItemId: itemDetail.id,
    }));

    setFocusComment((prev) => ({
      ...prev,
      staffComment: itemDetail.staffComment ?? '',
    }));

    setEditDimensionStorage(false);
  };

  const { data: itemDetailRs, refetch: onRefetchItems } = useQuery({
    queryKey: [QUERY_KEY.ITEM_DETAIL, id],
    queryFn: () => storageItemApi.storageItemControllerGetOneItemManagementAdmin(id),
    enabled: true,
    staleTime: 1000,
  });

  const createNote = useMutation({
    mutationFn: (dto: CreateStorageItemNoteDto) =>
      storageItemNotesApi.storageItemNoteControllerCreate(dto).then((res) => res?.data),
    onSuccess: () => {
      handleCloseRegisterNote();
      refetch();
    },
    onError: (error) => {},
  });

  const editNote = useMutation({
    mutationFn: ({ id, dto }: { id: string; dto: UpdateStorageItemNoteDto }) =>
      storageItemNotesApi.storageItemNoteControllerUpdate(id, dto).then((res) => res?.data),
    onSuccess: () => {
      handleCloseNoteItem();
      refetch();
      setIsEdit({ id: null, isOpen: false, content: '', data: undefined });
    },
    onError: (error) => {
      // handle error
    },
  });

  const deleteNote = useMutation({
    mutationFn: (id: string) => storageItemNotesApi.storageItemNoteControllerRemove(id),
    onSuccess: ({ data }) => {
      setOpenModalNoteDelete({ id: undefined, isOpen: false });
      NotificationSuccess({ content: '正常に削除されました。' });
      refetch();
    },
    onError: (error) => {
      // handle error
    },
  });

  const uploadRealVolume = useMutation({
    mutationFn: (itemCheckDto: UploadRealVolumeDto) =>
      storageProcessApi.storageProcessControllerUploadRealVolume(itemCheckDto),
    onSuccess: ({ data }) => {
      if (focusComment.open) {
        editStaffComment.mutate({ staffComment: focusComment.staffComment, storageItemId: itemDetail?.id });
        setFocusComment({ ...focusComment, open: false });
      }
      // onRefetchItems();
      setIsLoadingUpload(false);
    },
    onError: (error: any) => {
      const msgError: string = error?.response?.data?.message ?? '';
      if (msgError.includes('Hard:')) {
        NotificationError({ content: msgError });
      }
      setIsLoadingUpload(false);
    },
  });

  const uploadStorageVolume = useMutation({
    mutationFn: (itemCheckDto: UploadStorageVolumeDto) =>
      storageProcessApi.storageProcessControllerUploadStorageVolume(itemCheckDto),
    onSuccess: ({ data }) => {
      if (focusComment.open) {
        editStaffComment.mutate({ staffComment: focusComment.staffComment, storageItemId: itemDetail?.id });
        setFocusComment({ ...focusComment, open: false });
      }
      setIsLoadingUpload(false);
    },
    onError: (error: any) => {
      setIsLoadingUpload(false);
    },
  });

  const { mutate: RevertPreparingDone, isPending: isRevertPreparingDone } = useMutation({
    mutationFn: (dto: number) =>
      storageProcessApi.storageProcessControllerRevertPreparingDone({
        shipToBuyerRequestId: dto,
      }),
    onSuccess: ({ data }) => {
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.updateSuccess' }) });
      onRefetchItems();
    },
    onError: (error: any) => {},
  });

  useEffect(() => {
    const lst: StorageItemNote[] = [];
    listNote?.pages?.forEach((page) => {
      page?.data?.content?.forEach((staff) => {
        lst.push(staff);
      });
    });
    setLstNote(lst ?? []);
  }, [listNote]);

  useEffect(() => {
    if (inViewNote && listNote?.pages?.[0]?.data?.total > lstNote?.length) {
      fetchNextPage();
    }
  }, [inViewNote, listNote, lstNote]);

  useEffect(() => {
    if (itemDetailRs && itemDetailRs.data) {
      setItemDetail(itemDetailRs.data);
      setItemDetailStorageVol({
        ...itemDetailStorageVol,
      });
      setItemDetailRealVol({
        ...itemDetailRealVol,
      });
      setFocusComment({ ...focusComment, staffComment: itemDetailRs.data.staffComment });
    }
  }, [itemDetailRs]);

  const handleCloseModalCancel = () => {
    setActiveModalCancel(false);
  };
  const handleOpenAddPhoto = (rq: TakePhotoRequest) => {
    setActiveAddPhoto({ isShow: true, takePhotoRequest: rq });
  };
  const handleCloseAddPhoto = () => {
    setActiveAddPhoto({ isShow: false, takePhotoRequest: null });
  };

  // Admin huỷ yêu cầu chụp ảnh thêm (mọi trạng thái) — BE hoàn sau khi trừ キャンセル料 nên confirm nói rõ số tiền.
  const [pendingCancelPhotoRequest, setPendingCancelPhotoRequest] = useState<TakePhotoRequest | undefined>(undefined);
  // % キャンセル料 (料金設定 ACTIVE) để xem trước số tiền hoàn trong confirm.
  const { data: cancellationRate } = useCancellationRate();
  const cancelPhotoRequest = useMutation({
    mutationFn: (photoRequestId: number) => photoRequestApi.adminCancel(photoRequestId),
    onSuccess: () => {
      setPendingCancelPhotoRequest(undefined);
      onRefetchItems();
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.updateSuccess' }) });
    },
    onError: () => setPendingCancelPhotoRequest(undefined),
  });
  const handleOpenRegisterNote = () => {
    setActiveRegisterNote(true);
  };
  const handleCloseRegisterNote = () => {
    setActiveRegisterNote(false);
    form.resetFields();
  };
  const handleOpenNoteItem = (noteId: number) => {
    setMenuNote((prevState) => ({
      id: noteId,
      isOpenMenu: prevState.id !== noteId || !prevState.isOpenMenu,
    }));
  };
  const handleCloseNoteItem = () => {
    setNoteDetail(undefined);
    setIsEdit({ ...isEdit, isOpen: false, content: '', data: undefined });
  };

  const handleSendEditNote = (id) => {
    if (id) {
      editNote.mutateAsync({
        id,
        dto: { storageItemId: itemDetail.id, content: isEdit.content },
      });
    }
  };

  const handleEditNote = (noteId: number, content: string, data: StorageItemNote) => {
    if (noteId) {
      setIsEdit({ ...isEdit, id: noteId, isOpen: true, content: content, data: data });
      setMenuNote({ ...menuNote, isOpenMenu: false });
    }
  };
  const handleOpenNoteDelete = (noteId: number) => {
    setOpenModalNoteDelete({ ...openModalNoteDelete, id: noteId, isOpen: true });
    setMenuNote({ ...menuNote, isOpenMenu: false });
  };

  const handleCancelModal = () => {
    setOpenModalNoteDelete({ id: undefined, isOpen: false });
  };

  const handleSubmitDel = () => {
    if (openModalNoteDelete.id) {
      deleteNote.mutate(String(openModalNoteDelete.id));
    }
  };

  const handlePrintSKU = async () => {
    if (itemDetail?.internalSku) {
      await printSKU(itemDetail?.internalSku, intl.formatMessage({ id: 'error.500' }), true, setLoadingPrintSku);
    }
  };

  const handlePrintTrackingNumber = () => {
    if (renderTrackingNumber()) {
      window.open(itemDetail?.storageRequest?.shippoShippingLabel?.labelUrl);
    }
  };

  const handlePrintTrackingShipToBuyer = () => {
    if (itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingNumber) {
      window.open(itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.labelUrl);
    }
  };

  const handleRegisterNote = () => {
    const noteContent = form.getFieldValue('message')?.toString()?.trim();
    form.validateFields();
    if (!noteContent) {
      NotificationError({
        content: intl.formatMessage({ id: 'chat-item.send' }),
      });
      return;
    }
    if (id) {
      createNote.mutateAsync({ storageItemId: +id, content: noteContent, sendChatwork: false });
    }
  };

  const handleBackButton = () => {
    navigate(-1);
  };

  const renderListNote = useMemo(() => {
    return lstNote.map((note, index) => (
      <div
        className={`item-detail_feedback_content_item ${note.staffId == authUser?.id ? 'add-bg' : ''}`}
        key={index}
        ref={index === lstNote.length - 3 ? refNote : null}
      >
        <div className="item-detail_feedback_content_item_img">
          <img src={Helper.getSourceFile(note.staff.avatar?.source || note.staff.avatar?.preview)} alt="" />
        </div>
        <div className="wp-content">
          <div className="item-detail_feedback_content_item_text">
            <h6>{note.staff.name}</h6>
            <span>{moment(note.createdAt).format(TIME_FORMAT.MESSAGE_TIME)}</span>
            <Popover
              content={
                <div className={`note-dropdown-list`}>
                  <div className="note-dropdown-item" onClick={() => handleEditNote(note.id, note.content, note)}>
                    <span className="icon">
                      {' '}
                      <PenSvg />
                    </span>
                    <span className="text">編集</span>
                  </div>
                  <div className="note-dropdown-item" onClick={() => handleOpenNoteDelete(note.id)}>
                    <span className="icon">
                      <TrashSvg />
                    </span>
                    <span className="text">削除</span>
                  </div>
                </div>
              }
              overlayClassName={'popup-feedback'}
              trigger="hover"
              placement="bottomLeft"
              arrow={false}
              open={menuNote.isOpenMenu && menuNote.id === note.id}
              onOpenChange={() => handleOpenNoteItem(note.id)}
            >
              {note.staffId == authUser.id && (
                <button className="btn-more">
                  <MoreSvg />
                </button>
              )}
            </Popover>
          </div>
          <p
            className={`text-note ${expandBox ? 'text-break-line' : 'text-line'}`}
            dangerouslySetInnerHTML={{
              __html: note.content.replace(/\n/g, '<br />'),
            }}
          />
        </div>
      </div>
    ));
  }, [lstNote, menuNote, expandBox]);

  const renderTextStatusPhotoRequest = (status: string) => {
    let txtStatus = '';
    if (status == TAKE_PHOTO_REQUEST_STATUS.REQUESTED) {
      txtStatus = '写真撮影待ち';
    } else if (status == TAKE_PHOTO_REQUEST_STATUS.TAKE_BY_OPERATION) {
      txtStatus = '画像アップロード待ち';
    } else if (status == TAKE_PHOTO_REQUEST_STATUS.UPLOAD_BY_STAFF) {
      txtStatus = '対応済';
    } else if (status == TAKE_PHOTO_REQUEST_STATUS.CANCELED) {
      txtStatus = 'キャンセル済';
    }
    return txtStatus;
  };

  const renderTakePhotoRequest = useMemo(() => {
    return itemDetail?.takePhotoRequests?.map((rq) => {
      return (
        <tr>
          <td>
            <p>{moment(rq.createdAt).format(TIME_FORMAT.DATE('/'))}</p>
          </td>
          <td>
            <p>{rq.photoQuantity}</p>
          </td>
          <td>
            <p className="text-1-line">{rq.userMessage}</p>
          </td>
          <td className="item-detail_content_photo_table_wrap_status">
            <div className="item-detail_content_photo_table_wrap_status_cell">
              <p
                className={`item-detail_content_photo_table_wrap_status_${rq.status}`}
                onClick={() => {
                  // Yêu cầu đã huỷ: không mở modal chụp/upload nữa.
                  if (rq.status === TAKE_PHOTO_REQUEST_STATUS.CANCELED) return;
                  handleOpenAddPhoto(rq);
                }}
              >
                {renderTextStatusPhotoRequest(rq.status)}
              </p>
              {/* Admin huỷ được ở mọi trạng thái (kể cả 対応済) — rule KH 2026-10-05; user thì không huỷ được. */}
              {rq.status !== TAKE_PHOTO_REQUEST_STATUS.CANCELED && (
                <button
                  type="button"
                  className="item-detail_content_photo_table_wrap_status_cancel"
                  onClick={() => setPendingCancelPhotoRequest(rq)}
                >
                  キャンセル
                </button>
              )}
            </div>
          </td>
        </tr>
      );
    });
  }, [itemDetail]);

  const handleViewButton = (status: string) => {
    switch (status) {
      case STATUS_ITEM_MANAGEMENT.NOT_SHIPPED:
      case STATUS_ITEM_MANAGEMENT.IN_TRANSIT:
      case STATUS_ITEM_MANAGEMENT.DELIVERED:
      case STATUS_ITEM_MANAGEMENT.TEMPORARY_CANCELED:
      case STATUS_ITEM_MANAGEMENT.WAITING_UPLOAD_IMAGE_VIDEO:
      case STATUS_ITEM_MANAGEMENT.IN_STORAGE_HAS_CHECK_FLAG:
        return itemDetail.checkedFlag ? 'registration' : 'inspectionComplete';
      case STATUS_ITEM_MANAGEMENT.NEW_DISPOSAL_REQUEST:
        return 'disposalAmountRegistration';
      case STATUS_ITEM_MANAGEMENT.PRICE_INPUTED:
        return 'disposalCompleted';
      default:
        return '';
    }
  };

  const submitUpload = () => {
    formUploadByStatus.submit();
  };

  const hasAnyPositive = (values: Array<number | undefined | null>) =>
    values.some((v) => v != null && Number.isFinite(v) && v > 0);

  const isCompletePositive = (values: Array<number | undefined | null>) =>
    values.every((v) => v != null && Number.isFinite(v) && v > 0);

  const validateDecimal2 = (value: number | undefined | null, type: 'real' | 'storage' = 'real') => {
    if (value != null && Number.isFinite(value) && countDecimalPlaces(value) > 2) {
      NotificationError({ content: '小数点以下は2桁まで入力してください。' });

      if (type === 'real') {
        setRealError((prev) => ({ ...prev, weight: true }));
      } else {
        setStorageError((prev) => ({ ...prev, weight: true }));
      }

      return false;
    }
    return true;
  };

  type DimensionField = 'length' | 'width' | 'height';

  const MAX_INCH_WHOLE = 999;
  const MAX_INCH_QUARTER = 3;

  const validateMaxInch = (cm: number | undefined | null, field: DimensionField, type: 'real' | 'storage'): boolean => {
    if (cm == null || !Number.isFinite(cm) || cm <= 0) return true;

    const parts = cmToInchParts(cm, 'nearest');
    if (!parts) return true;

    const { whole, quarter } = parts;

    const isOver = whole > MAX_INCH_WHOLE || (whole === MAX_INCH_WHOLE && quarter > MAX_INCH_QUARTER);

    if (!isOver) return true;

    NotificationError({
      content: 'サイズは最大 999 3/4 inch まで入力可能です。',
    });

    if (type === 'real') {
      setRealError((prev) => ({ ...prev, [field]: true }));
    } else {
      setStorageError((prev) => ({ ...prev, [field]: true }));
    }

    return false;
  };

  const submitSize = async () => {
    setIsLoadingUpload(true);
    setIsOpenCheck(false);
    setRealError({ length: false, width: false, height: false, weight: false });
    setStorageError({ length: false, width: false, height: false, weight: false });

    if (!itemDetail) {
      setIsLoadingUpload(false);
      return;
    }

    const realVol = itemDetailRealVol;
    const storageVol = itemDetailStorageVol;

    const realFields = [realVol.realLength, realVol.realWidth, realVol.realHeight, realVol.realWeight];

    const storageFields = [
      storageVol.storageLength,
      storageVol.storageWidth,
      storageVol.storageHeight,
      storageVol.storageWeight,
    ];

    const hasRealAny = hasAnyPositive(realFields);
    const hasStorageAny = hasAnyPositive(storageFields);

    const isMissingRealFromRequest =
      !itemDetail?.storageRequest?.realHeight ||
      !itemDetail?.storageRequest?.realWeight ||
      !itemDetail?.storageRequest?.realWidth ||
      !itemDetail?.storageRequest?.realLength;

    if (!hasRealAny && !hasStorageAny) {
      NotificationError({ content: '整数を入力してください。' });
      setIsLoadingUpload(false);
      return;
    }

    const shouldAutoFillRealFromStorage = isMissingRealFromRequest && hasStorageAny && !hasRealAny;

    const realPayload = shouldAutoFillRealFromStorage
      ? {
          ...realVol,
          realLength: storageVol.storageLength,
          realWidth: storageVol.storageWidth,
          realHeight: storageVol.storageHeight,
          realWeight: storageVol.storageWeight,
        }
      : realVol;

    const realFieldsToValidate = [
      realPayload.realLength,
      realPayload.realWidth,
      realPayload.realHeight,
      realPayload.realWeight,
    ];

    let hasError = false;

    if (isMissingRealFromRequest && (hasRealAny || shouldAutoFillRealFromStorage)) {
      if (!isCompletePositive(realFieldsToValidate)) {
        handleShowNotiRealError();
        hasError = true;
      }
      if (!validateDecimal2(realPayload.realWeight, 'real')) {
        hasError = true;
      }
    }

    if (hasStorageAny) {
      if (!isCompletePositive(storageFields)) {
        handleShowNotiError();
        hasError = true;
      }
      if (!validateDecimal2(storageVol.storageWeight, 'storage')) {
        hasError = true;
      }
    }

    if (hasError) {
      setIsLoadingUpload(false);
      return;
    }

    const shouldUploadReal = isMissingRealFromRequest && (hasRealAny || shouldAutoFillRealFromStorage);

    const shouldUploadStorage = hasStorageAny;

    const tasks: Promise<any>[] = [];

    if (shouldUploadReal) {
      tasks.push(
        uploadRealVolume.mutateAsync({
          ...realPayload,
          storageItemId: itemDetail.id,
        }),
      );
    }

    if (shouldUploadStorage) {
      tasks.push(
        uploadStorageVolume.mutateAsync({
          ...storageVol,
          storageItemId: itemDetail.id,
        }),
      );
    }

    if (tasks.length === 0) {
      setIsLoadingUpload(false);
      return;
    }

    const results = await Promise.allSettled(tasks);

    const hasFail = results.some((r) => r.status === 'rejected');
    if (hasFail) {
      setIsLoadingUpload(false);
      return;
    }

    NotificationSuccess({ content: intl.formatMessage({ id: 'common.updateSuccess' }) });

    if (focusComment.open) {
      editStaffComment.mutate({
        staffComment: focusComment.staffComment,
        storageItemId: itemDetail.id,
      });
      setFocusComment({ ...focusComment, open: false });
    }

    onRefetchItems();
    setIsLoadingUpload(false);
  };

  // Item CHƯA LƯU KHO (storageFromDate null) bị hủy: operator phải nhập size/weight ngay trong modal
  // xác nhận để BE tính phí bảo quản (firstUploadImageAt -> ngày hủy, cùng logic markShipped).
  const needDisposalDims = !itemDetail?.storageFromDate;

  /** Validate 4 ô ở modal サイズ・重量入力; đủ thì sang modal xác nhận hủy (giống bước dimension của ship gộp). */
  const handleNextFromDisposalDims = () => {
    const nextError = {
      length: !disposalDims.length || disposalDims.length <= 0,
      width: !disposalDims.width || disposalDims.width <= 0,
      height: !disposalDims.height || disposalDims.height <= 0,
      weight: !disposalDims.weight || disposalDims.weight <= 0,
    };
    setDisposalDimsError(nextError);
    if (Object.values(nextError).some(Boolean)) {
      NotificationError({ content: intl.formatMessage({ id: 'common.fail' }) });
      return;
    }
    setIsOpenDisposalDims(false);
    setIsOpenConfirm(true);
  };

  const confirmDisposal = () => {
    if (needDisposalDims) {
      // An toàn: tới confirm mà thiếu dims (không đi qua modal size) -> quay lại modal size
      if (!disposalDims.length || !disposalDims.width || !disposalDims.height || !disposalDims.weight) {
        setIsOpenConfirm(false);
        setIsOpenDisposalDims(true);
        return;
      }
      completedDisposalMutation.mutate({
        disposalRequestId: itemDetail?.disposalRequest?.id,
        length: disposalDims.length,
        width: disposalDims.width,
        height: disposalDims.height,
        weight: disposalDims.weight,
      } as any);
      return;
    }

    completedDisposalMutation.mutate({ disposalRequestId: itemDetail?.disposalRequest?.id });
  };
  const handleActionButton = (status: string) => {
    const isMissingRealFromRequest =
      !itemDetail?.storageRequest?.realHeight ||
      !itemDetail?.storageRequest?.realWeight ||
      !itemDetail?.storageRequest?.realWidth ||
      !itemDetail?.storageRequest?.realLength;

    switch (status) {
      case STATUS_ITEM_MANAGEMENT.NOT_SHIPPED:
      case STATUS_ITEM_MANAGEMENT.IN_TRANSIT:
      case STATUS_ITEM_MANAGEMENT.DELIVERED:
      case STATUS_ITEM_MANAGEMENT.TEMPORARY_CANCELED:
      case STATUS_ITEM_MANAGEMENT.WAITING_UPLOAD_IMAGE_VIDEO:
      case STATUS_ITEM_MANAGEMENT.IN_STORAGE_HAS_CHECK_FLAG: {
        if (isMissingRealFromRequest) {
          return handleCheckPercentDiff();
        }
        if (!itemDetail.storageRequest.realWeight || !itemDetail.storageWeight) return submitSize();
        if (!itemDetail.uploadedImageVideoFlg) return submitUpload();
        return;
      }

      case STATUS_ITEM_MANAGEMENT.NEW_DISPOSAL_REQUEST:
        return setIsOpen(true);

      case STATUS_ITEM_MANAGEMENT.PRICE_INPUTED:
        // Item CHƯA LƯU KHO: mở modal サイズ・重量入力 (y hệt bước dimension của ship-to-buyer gộp)
        // TRƯỚC, xong mới tới modal xác nhận hủy. Item đã lưu kho: confirm luôn như cũ.
        if (needDisposalDims) return setIsOpenDisposalDims(true);
        return setIsOpenConfirm(true);

      default:
        return undefined;
    }
  };

  const handleRemovePhoto = () => {
    if (removePhoto?.id) {
      AssetMutation(removePhoto?.id as string);
      setRemovePhoto(undefined);
    }
  };

  const renderStatusItem = useMemo(() => {
    return <ViewStatus status={statusItem || ''} />;
  }, [itemDetail]);

  useEffect(() => {
    if (itemDetail?.id) {
      setItemDetailStorageVol({
        storageHeight: itemDetail.storageHeight ?? itemDetailStorageVol.storageHeight,
        storageWeight: itemDetail.storageWeight ?? itemDetailStorageVol.storageWeight,
        storageWidth: itemDetail.storageWidth ?? itemDetailStorageVol.storageWidth,
        storageLength: itemDetail.storageLength ?? itemDetailStorageVol.storageLength,
        storageItemId: itemDetail.id,
      });
      setItemDetailRealVol({
        realHeight: itemDetail.storageRequest.realHeight ?? itemDetailRealVol.realHeight,
        realWeight: itemDetail.storageRequest.realWeight ?? itemDetailRealVol.realWeight,
        realWidth: itemDetail.storageRequest.realWidth ?? itemDetailRealVol.realWidth,
        realLength: itemDetail.storageRequest.realLength ?? itemDetailRealVol.realLength,
        isDeformed: itemDetail.storageRequest.isDeformed || itemDetailRealVol.isDeformed,
        isNonCarton: itemDetail.storageRequest.isNonCarton || itemDetailRealVol.isNonCarton,
        storageItemId: itemDetail.id,
      });
      setFocusComment({ ...focusComment, staffComment: itemDetail.staffComment });
    }
  }, [itemDetail]);

  useEffect(() => {
    if (
      itemDetail?.storageRequest?.unboxVideoFee !== 0 &&
      itemDetail?.videos?.length === 0 &&
      itemDetail?.storageRequest.status !== STATUS_ITEM_MANAGEMENT.CANCELED
    ) {
      setIsOpenNotifyUpload(true);
    }
  }, [itemDetail]);

  const renderListPhoto = useMemo(() => {
    const base = itemDetail?.photos ?? [];
    const extra = (itemDetail?.takePhotoRequests ?? []).flatMap((rq) => rq?.photos ?? []);
    const sorted = sortByParenIndex([...base, ...extra]);

    return sorted.map((item, index) => (
      <div key={item.id ?? `p-${index}`} className="item-detail_content_photo_list_item position-relative">
        <Image
          onClick={() => {
            setVisibleSender(true);
            setPreviewSender({ source: item?.source, index: index + 1 });
          }}
          width={84}
          height={84}
          className="rounded"
          src={Helper.getSourceFile(item?.source)}
        />
        <div
          className="remove-item position-absolute bottom-0 end-0"
          onClick={() => setRemovePhoto({ open: true, id: item?.id })}
        ></div>
      </div>
    ));
  }, [itemDetail?.photos, itemDetail?.takePhotoRequests]);

  const renderListVideo: React.ReactNode = useMemo(() => {
    const videos = itemDetail?.videos ?? [];
    const sorted = sortByParenIndex([...videos]);

    return sorted.map((item, index) => (
      <div key={item.id ?? `v-${index}`} className="item-detail_content_video_list_item">
        <VideoModal
          privew={<img src="/assets/icons/item-detail-demo.png" alt="" />}
          url={Helper.getSourceFile(item?.source)}
        />
      </div>
    ));
  }, [itemDetail?.videos]);

  const isDisableInput = useMemo(() => !arrStatusInputMeasure.includes(statusItem), [itemDetail]);

  const updatePriceMutation = useMutation({
    mutationFn: (dto: UpdateDisposalRequestDto) => storageProcessApi.storageProcessControllerUpdateDisposalPrice(dto),
    onSuccess: ({ data }) => {
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.updateSuccess' }) });
      setIsOpen(false);
      onRefetchItems();
    },
    onError: (error: any) => {},
  });

  const completedDisposalMutation = useMutation({
    mutationFn: (dto: UpdateDisposalRequestDto) => storageProcessApi.storageProcessControllerDisposalItem(dto),
    onSuccess: ({ data }) => {
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.updateSuccess' }) });
      setIsOpenConfirm(false);
      onRefetchItems();
    },
    onError: (error: any) => {},
  });
  const onFinishFailedUpdatePrice = () => {
    formUpdateItem.validateFields();
    NotificationError({
      content: `${intl.formatMessage({ id: 'item.detail.disposalAmount' })}を入力`,
    });
  };
  const onFinishUpdatePrice = (value: UpdateDisposalRequestDto) => {
    if (value.price) {
      const price = value.price ? +value.price : 0;
      updatePriceMutation.mutate({
        disposalRequestId: itemDetail.disposalRequest?.id,
        price,
      });
    }
  };

  const handleShowNotiError = () => {
    const next = { length: false, width: false, height: false, weight: false };

    if (!itemDetailStorageVol.storageLength || itemDetailStorageVol.storageLength <= 0) {
      next.length = true;
      NotificationError({ content: `${intl.formatMessage({ id: 'item.detail.length' })}を入力` });
    }
    if (!itemDetailStorageVol.storageWidth || itemDetailStorageVol.storageWidth <= 0) {
      next.width = true;
      NotificationError({ content: `${intl.formatMessage({ id: 'item.detail.width' })}を入力` });
    }
    if (!itemDetailStorageVol.storageHeight || itemDetailStorageVol.storageHeight <= 0) {
      next.height = true;
      NotificationError({ content: `${intl.formatMessage({ id: 'item.detail.height' })}を入力` });
    }
    if (!itemDetailStorageVol.storageWeight || itemDetailStorageVol.storageWeight <= 0) {
      next.weight = true;
      NotificationError({ content: `${intl.formatMessage({ id: 'item.detail.storageWeight' })}を入力` });
    }

    setStorageError(next);
  };

  const handleShowNotiRealError = () => {
    const next = { length: false, width: false, height: false, weight: false };

    if (!itemDetailRealVol.realLength || itemDetailRealVol.realLength <= 0) {
      next.length = true;
      NotificationError({ content: `${intl.formatMessage({ id: 'item.detail.length' })}を入力` });
    }
    if (!itemDetailRealVol.realWidth || itemDetailRealVol.realWidth <= 0) {
      next.width = true;
      NotificationError({ content: `${intl.formatMessage({ id: 'item.detail.width' })}を入力` });
    }
    if (!itemDetailRealVol.realHeight || itemDetailRealVol.realHeight <= 0) {
      next.height = true;
      NotificationError({ content: `${intl.formatMessage({ id: 'item.detail.height' })}を入力` });
    }
    if (!itemDetailRealVol.realWeight || itemDetailRealVol.realWeight <= 0) {
      next.weight = true;
      NotificationError({ content: `${intl.formatMessage({ id: 'item.detail.storageWeight' })}を入力` });
    }

    setRealError(next);
  };

  const handleCheckPercentDiff = () => {
    const realFields: Array<number | undefined | null> = [
      itemDetailRealVol.realLength,
      itemDetailRealVol.realWidth,
      itemDetailRealVol.realHeight,
      itemDetailRealVol.realWeight,
    ];

    const hasRealAny = realFields.some((v) => v != null && Number.isFinite(v) && v > 0);
    const hasAll4Real = realFields.every((v) => v != null && Number.isFinite(v) && v > 0);

    if (!hasRealAny || !hasAll4Real) {
      submitSize();
      return;
    }

    const reportLength: number = itemDetail?.storageRequest?.reportLength ?? 0;
    const reportHeight: number = itemDetail?.storageRequest?.reportHeight ?? 0;
    const reportWidth: number = itemDetail?.storageRequest?.reportWidth ?? 0;
    const reportWeight: number = itemDetail?.storageRequest?.reportWeight ?? 0;
    const reportCapacity: number = (reportLength * reportHeight * reportWidth) / 5000;

    const realLength: number = itemDetailRealVol.realLength ?? 0;
    const realHeight: number = itemDetailRealVol.realHeight ?? 0;
    const realWidth: number = itemDetailRealVol.realWidth ?? 0;
    const realWeight: number = itemDetailRealVol.realWeight ?? 0;
    const realCapacity: number = (realLength * realHeight * realWidth) / 5000;

    const percentDifference: number = Number((((realCapacity - reportCapacity) / reportCapacity) * 100).toFixed());
    const percentDifferenceWeight: number = Number((((realWeight - reportWeight) / reportWeight) * 100).toFixed());

    if (percentDifference >= 20 || percentDifferenceWeight >= 20) {
      setIsOpenCheck(true);
      return;
    }

    submitSize();
  };

  const editStaffComment = useMutation({
    mutationKey: ['editStaffComment'],
    mutationFn: (uploadStaffCommentDto: UploadStaffCommentDto) =>
      storageProcessApi.storageProcessControllerEditStaffComment(uploadStaffCommentDto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY.ITEM_DETAIL],
        stale: true,
      });
      NotificationSuccess({ content: intl.formatMessage({ id: 'common.createSuccess' }) });
      setFocusComment({ ...focusComment, open: false });
    },
  });

  const handleButtonClick = (popupId) => {
    setActivePopup(popupId === activePopup ? null : popupId);
  };

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setActivePopup(null);
    }
  };

  useEffect(() => {
    if (activePopup !== null) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activePopup]);

  const getDiffFee = (itemDetail: StorageItem) => {
    const { realBaseFee, baseFee, appliedCouponRate } = itemDetail;

    if (realBaseFee && realBaseFee > baseFee) {
      const diffBase = realBaseFee - baseFee - ((realBaseFee - baseFee) / 100) * appliedCouponRate || 0;
      return `$${Number(diffBase.toFixed(2))}`;
    }
    return '';
  };

  const calculatorStorageFee = useCallback(
    (numOfDay: number) => {
      if (!itemDetail?.storageLength || !itemDetail?.storageHeight || !itemDetail?.storageWidth) return 0;
      const volumeWeight =
        ((itemDetail?.storageLength || 0) * (itemDetail?.storageHeight || 0) * (itemDetail?.storageWidth || 0)) / 5000;
      const oneDayFeeElement1 =
        (itemDetail?.storageWeight || 0) * (itemDetail?.storageRequest?.planVersionPattern?.storageFeeConstWeight || 0);
      const oneDayFeeElement2 = volumeWeight * itemDetail?.storageRequest?.planVersionPattern?.storageFeeConstWeight;
      const oneDayFeeElement3 =
        (itemDetail?.itemPrice || 0) * (itemDetail?.storageRequest?.planVersionPattern?.storageFeeConstPrice || 0);

      const minStorageFee = itemDetail?.storageRequest?.planVersionPattern?.minStorageFee || 0;
      const Max = max([oneDayFeeElement1, oneDayFeeElement2, oneDayFeeElement3]);
      const oneDayFee = Max > minStorageFee ? Max : minStorageFee;
      return numOfDay * Number(oneDayFee.toFixed(2));
    },
    [itemDetail],
  );

  const numOfDayStorageFeeOfLastMonth = useMemo(() => {
    const start = itemDetail?.storageFromDate ?? itemDetail?.storageItemRack?.createdAt;
    if (!start) return 0;

    const tz = AmericaTimezone;

    // Khoảng lưu kho thực tế
    const storageStart = moment.tz(start, tz).startOf('day');
    const storageEnd = (itemDetail?.storageToDate ? moment.tz(itemDetail.storageToDate, tz) : moment.tz(tz)).endOf(
      'day',
    );

    // Khoảng của THÁNG TRƯỚC
    const now = moment.tz(tz);
    const lastMonthStart = now.clone().subtract(1, 'month').startOf('month').startOf('day');
    const lastMonthEnd = now.clone().subtract(1, 'month').endOf('month').endOf('day');

    // Lấy giao nhau giữa 2 khoảng
    const rangeStart = moment.max(storageStart, lastMonthStart);
    const rangeEnd = moment.min(storageEnd, lastMonthEnd);

    if (rangeEnd.isBefore(rangeStart)) return 0; // không giao nhau → 0 ngày

    // +1 để tính inclusive theo ngày
    return rangeEnd.diff(rangeStart, 'days') + 1;
  }, [itemDetail, AmericaTimezone]);

  /**
   * Item CHƯA LƯU KHO (không có 保管サイズ) vẫn có thể phát sinh phí bảo quản — row
   * StorageMonthlyPayment tạo lúc hủy/ship theo dims operator nhập (storage-fee-unstored-ship.plan.md).
   * Panel không tự tính được theo dims (calculatorStorageFee trả 0) -> đọc thẳng các row (nguồn billing
   * thật). Item có 保管サイズ: trả null, giữ nguyên cách tự tính cũ.
   */
  const unstoredFeeFromRows = useMemo(() => {
    const hasStorageDims = !!itemDetail?.storageLength && !!itemDetail?.storageHeight && !!itemDetail?.storageWidth;
    if (hasStorageDims) return null;
    const rows: any[] = (itemDetail as any)?.storageMonthlyPayments ?? [];
    if (!rows.length) return null;
    const now = moment().tz(AmericaTimezone);
    const inMonth = (d: any, m: any) => {
      const x = moment(d).tz(AmericaTimezone);
      return x.year() === m.year() && x.month() === m.month();
    };
    const sum = (filter: (r: any) => boolean) =>
      rows.filter(filter).reduce((t, r) => t + Number(r.chargeAmount || 0), 0);
    return {
      total: sum(() => true),
      thisMonth: sum((r) => inMonth(r.storageFromDate, now)),
      lastMonth: sum((r) => inMonth(r.storageFromDate, now.clone().subtract(1, 'month'))),
    };
  }, [itemDetail]);

  const renderStorageFeeOfLastMonth = useMemo(() => {
    const fee = unstoredFeeFromRows
      ? unstoredFeeFromRows.lastMonth
      : calculatorStorageFee(numOfDayStorageFeeOfLastMonth);

    return fee > 0 ? `$${Number(fee.toFixed(2))}` : '';
  }, [itemDetail]);

  const numOfDayStorageFeeOfThisMonth = useMemo(() => {
    if (!itemDetail) return null;

    const startRaw = itemDetail.storageFromDate ?? itemDetail.storageItemRack?.createdAt;
    if (!startRaw) return null;

    const storageAt = moment(startRaw).tz(AmericaTimezone);
    const now = moment().tz(AmericaTimezone);

    // Nếu storageToDate null => lấy ngày hôm nay
    let current = itemDetail?.storageToDate ? moment(itemDetail.storageToDate).tz(AmericaTimezone) : now;

    const startOfThisMonth = now.clone().startOf('month').startOf('day');
    const endOfThisMonth = now.clone().endOf('month').endOf('day');

    // Giới hạn current không vượt quá cuối tháng
    if (current.isAfter(endOfThisMonth)) {
      current = endOfThisMonth;
    }

    // Nếu storageToDate < startOfThisMonth => không tính
    if (itemDetail?.storageToDate && moment(itemDetail.storageToDate).isBefore(startOfThisMonth)) {
      return 0;
    }

    // Nếu storageAt > endOfThisMonth => không tính
    if (storageAt.isAfter(endOfThisMonth)) {
      return 0;
    }

    // Tính khoảng giao nhau giữa [storageAt → current] và [startOfThisMonth → endOfThisMonth]
    const effectiveStart = moment.max(storageAt, startOfThisMonth);
    const effectiveEnd = moment.min(current, endOfThisMonth);

    const numOfDay = effectiveEnd.diff(effectiveStart.startOf('day'), 'days') + 1;

    return numOfDay > 0 ? numOfDay : 0;
  }, [itemDetail?.storageFromDate, itemDetail?.storageToDate, itemDetail?.storageItemRack?.createdAt]);

  const renderStorageFeeOfThisMonth = useMemo(() => {
    const fee = unstoredFeeFromRows
      ? unstoredFeeFromRows.thisMonth
      : calculatorStorageFee(numOfDayStorageFeeOfThisMonth);

    return fee > 0 ? `$${Number(fee.toFixed(2))}` : '';
  }, [itemDetail]);

  const numOfDayTotalStorageFee = useMemo(() => {
    if (!itemDetail?.storageFromDate) return 0;
    const storageAt = moment(itemDetail.storageFromDate).tz(AmericaTimezone);
    const storageTo = itemDetail.storageToDate
      ? moment(itemDetail.storageToDate).tz(AmericaTimezone)
      : moment().tz(AmericaTimezone);

    return storageTo.startOf('day').diff(storageAt.startOf('day').format(TIME_FORMAT.DATE('/')), 'days') + 1;
  }, [itemDetail]);

  const renderTotalStorageFee = useMemo(() => {
    const fee = unstoredFeeFromRows ? unstoredFeeFromRows.total : calculatorStorageFee(numOfDayTotalStorageFee);
    return fee > 0 ? `$${Number(fee.toFixed(2))}` : '';
  }, [itemDetail]);

  const updateTrackingNumber = useMutation({
    mutationFn: (data: UpdateTrackingNumber) => storageProcessApi.storageProcessControllerUpdateTrackingNumber(data),
    onSuccess: ({ data }) => {
      setActionEditTrackingNumber(false);
      NotificationSuccess({ content: '正常に更新されました。' });
      onRefetchItems();
    },
  });

  const handelUpdateTrackingNumber = () => {
    const trackingNumber = formTrackingNumber.getFieldValue('trackingNumber');
    return updateTrackingNumber.mutate({
      storageItemId: itemDetail?.id,
      storageRequestId: itemDetail?.storageRequestId,
      trackingNumberProvided: trackingNumber.trim(),
    });
  };

  const handleEditTrackingNumber = () => {
    setActionEditTrackingNumber(true);
  };

  const renderTrackingNumber = () => {
    if (actionEditTrackingNumber) {
      return (
        <>
          <Form form={formTrackingNumber}>
            <Form.Item name="trackingNumber">
              <Input type="text" />
            </Form.Item>
          </Form>
          <div className="group-action">
            <span onClick={() => setActionEditTrackingNumber(false)}>
              <SvgIconX />
            </span>
            <span onClick={handelUpdateTrackingNumber}>
              <SvgIconCheck />
            </span>
          </div>
        </>
      );
    }
    return (
      itemDetail?.storageRequest?.shippoShippingLabel?.trackingNumber ??
      itemDetail?.storageRequest?.trackingNumberProvided ??
      ''
    );
  };

  const renderReturnDeliveredDate = () => {
    let trackingHistory = itemDetail?.storageRequest?.shippoShippingLabel?.trackingHistory
      ? JSON.parse(itemDetail?.storageRequest?.shippoShippingLabel?.trackingHistory)
      : [];
    let shippoDeliveredDate = trackingHistory.find((h) => h?.status == 'DELIVERED');
    if (itemDetail?.storageRequest?.deliveredAt && shippoDeliveredDate) {
      if (
        moment(itemDetail?.storageRequest?.deliveredAt).isBefore(
          shippoDeliveredDate?.status_date ?? shippoDeliveredDate?.statusDate,
        )
      ) {
        return moment(itemDetail?.storageRequest?.deliveredAt).tz(AmericaTimezone).format(TIME_FORMAT.DATE('/'));
      } else {
        return moment(shippoDeliveredDate?.status_date ?? shippoDeliveredDate?.statusDate)
          .tz(AmericaTimezone)
          .format(TIME_FORMAT.DATE('/'));
      }
    } else if (itemDetail?.storageRequest?.deliveredAt || shippoDeliveredDate) {
      return moment(
        itemDetail?.storageRequest?.deliveredAt ?? shippoDeliveredDate?.status_date ?? shippoDeliveredDate?.statusDate,
      )
        .tz(AmericaTimezone)
        .format(TIME_FORMAT.DATE('/'));
    } else return '';
  };

  const cancelStorageRequestMutation = useMutation({
    mutationFn: (data: CancelStorageRequest) => storageProcessApi.storageProcessControllerCancelStorageRequest(data),
    onSuccess: (data, variables) => {
      onRefetchItems();
      NotificationSuccess({ content: '依頼をキャンセルしました。' });
    },
  });

  const cancelShipToBuyerRequestMutation = useMutation({
    mutationFn: (data: CancelShipToBuyerDto) =>
      storageProcessApi.storageProcessControllerCancelShipToBuyerRequest(data),
    onSuccess: (data, variables) => {
      onRefetchItems();
      NotificationSuccess({ content: '依頼をキャンセルしました。' });
    },
  });

  const handleOpenModalAction = () => {
    let action = '';
    if (
      itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.status === STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING ||
      itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.status === STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING_DONE
    ) {
      action = REQUEST_ACTION_ITEM_DETAIL.CANCEL_SHIP_TO_BUYER_REQUEST;
    } else if (
      itemDetail?.storageRequest?.storageItems?.every((item) => item.checkedFlag === false) &&
      itemDetail?.storageRequest?.status != STATUS_ITEM_MANAGEMENT.CANCELED
    ) {
      action = REQUEST_ACTION_ITEM_DETAIL.CANCEL_STORAGE_REQUEST;
    }
    setActiveModalCancelRequest({ isShow: true, action: action });
  };

  const handleCloseModalCancelRequest = () => {
    setActiveModalCancelRequest({ isShow: false, action: null });
  };

  const handleActiveCancel = () => {
    if (activeModalCancelRequest.action == REQUEST_ACTION_ITEM_DETAIL.CANCEL_STORAGE_REQUEST) {
      cancelStorageRequestMutation.mutate({ storageRequestId: itemDetail?.storageRequest?.id });
    } else if (activeModalCancelRequest.action == REQUEST_ACTION_ITEM_DETAIL.CANCEL_SHIP_TO_BUYER_REQUEST) {
      cancelShipToBuyerRequestMutation.mutate({
        shipToBuyerRequestId: itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.id,
      } as CancelShipToBuyerDto);
    }
    handleCloseModalCancelRequest();
  };

  const renderButtonCancel = useMemo(() => {
    let labelBtnCancel = '';
    if (itemDetail?.storageRequest?.status === STATUS_ITEM_MANAGEMENT.CANCELED) return;
    if (
      itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.status === STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING ||
      itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.status === STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING_DONE
    ) {
      labelBtnCancel = '発送依頼キャンセル';
    } else if (
      itemDetail?.storageRequest?.storageItems?.every((item) => item.checkedFlag === false) &&
      itemDetail?.storageRequest?.status != STATUS_ITEM_MANAGEMENT.CANCELED
    ) {
      labelBtnCancel = '依頼キャンセル';
    }

    if (labelBtnCancel) {
      return (
        <button
          className={`item-detail_content_top_button-wrap_disposal-request`}
          style={{ width: 'fit-content', padding: '0 12px' }}
          onClick={handleOpenModalAction}
        >
          {labelBtnCancel}
        </button>
      );
    } else {
      return null;
    }
  }, [itemDetail]);

  const renderButtonRevert = useMemo(() => {
    let labelBtnCancel = '';
    if (itemDetail?.storageRequest?.status === STATUS_ITEM_MANAGEMENT.CANCELED) return;
    if (itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.status === STATUS_ITEM_MANAGEMENT.SHIPPING_PREPARING_DONE) {
      labelBtnCancel = '発送準備完了取消';

      return (
        labelBtnCancel && (
          <button
            className={`item-detail_content_top_button-wrap_disposal-request`}
            style={{ width: 'fit-content', padding: '0 12px' }}
            onClick={() => setActiveModalRevert(true)}
            disabled={isRevertPreparingDone}
          >
            {labelBtnCancel}
          </button>
        )
      );
    } else {
      return null;
    }
  }, [itemDetail, isRevertPreparingDone]);

  const renderModalConfirmCancel = useMemo(() => {
    let txt = '';
    if (activeModalCancelRequest.action == REQUEST_ACTION_ITEM_DETAIL.CANCEL_STORAGE_REQUEST) {
      txt = '保管依頼を本当にキャンセルしますか？';
    } else if (activeModalCancelRequest.action == REQUEST_ACTION_ITEM_DETAIL.CANCEL_SHIP_TO_BUYER_REQUEST) {
      txt = '発送依頼を本当にキャンセルしますか？';
    }
    return txt;
  }, [activeModalCancelRequest]);

  const itemPrice = itemDetail?.itemPrice ?? 0;
  const insurancePercentFee = itemDetail?.storageRequest?.insuranceFee ? (itemPrice * 1.25) / 100 : 0;

  const storageItemsLength = itemDetail?.storageRequest?.storageItems?.length || 1;
  const unboxVideoFee = (itemDetail?.storageRequest?.unboxVideoFee ?? 0) / storageItemsLength;

  const shipToBuyerInsuranceFee = itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.insuranceFee ?? 0;

  const takePhotoTotalFee =
    itemDetail?.takePhotoRequests?.reduce((acc, request) => {
      // Yêu cầu đã huỷ: chỉ còn キャンセル料 giữ lại (cancelFee), phần còn lại đã hoàn.
      const fee =
        request?.status === TAKE_PHOTO_REQUEST_STATUS.CANCELED
          ? (request as any)?.cancelFee ?? 0
          : request?.chargeAmount ?? 0;
      return acc + fee;
    }, 0) ?? 0;

  const totalOptionFee = insurancePercentFee + unboxVideoFee + shipToBuyerInsuranceFee + takePhotoTotalFee;

  const canShowAction = !actionEditTrackingNumber && itemDetail?.status !== STATUS_ITEM_MANAGEMENT.CANCELED;

  const hasLabelUrl = itemDetail?.storageRequest?.shippoShippingLabel?.labelUrl;
  const handlePrint = () => {
    window.open(itemDetail?.storageRequest?.shippoShippingLabel?.labelUrl);
  };
  const renderAction = () => {
    if (hasLabelUrl && itemDetail?.status !== STATUS_ITEM_MANAGEMENT.CANCELED) {
      return (
        <span onClick={handlePrint}>
          <PrintIcon />
        </span>
      );
    }
    if (canShowAction)
      return (
        <span onClick={handleEditTrackingNumber}>
          <SvgPencil />
        </span>
      );
  };
  const handleStartEditItemInfo = () => {
    if (!itemDetail) return;
    setItemInfoDraft({
      internalSku: itemDetail.internalSku ?? '',
      itemSku: itemDetail.itemSku ?? '',
      itemName: decodeHtml(itemDetail.itemName || ''),
    });
    setIsEditItemInfo(true);
  };

  const handleCancelEditItemInfo = () => {
    if (!itemDetail) {
      setIsEditItemInfo(false);
      return;
    }
    setItemInfoDraft({
      internalSku: itemDetail.internalSku ?? '',
      itemSku: itemDetail.itemSku ?? '',
      itemName: decodeHtml(itemDetail.itemName || ''),
    });
    setIsEditItemInfo(false);
  };

  const handleSaveItemInfo = () => {
    if (!itemDetail?.id) return;

    if (!hasItemInfoChanged) {
      setIsEditItemInfo(false);
      return;
    }

    const payload = {
      storageItemId: itemDetail.id,
      itemInformation: {
        internalSku: !['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JNE', 'JLY', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'].some(
          (month) => itemDetail.internalSku.includes(month),
        )
          ? itemInfoDraft.internalSku.trim()
          : undefined,
        itemSku: itemInfoDraft.itemSku.trim(),
        itemName: itemInfoDraft.itemName.trim(),
      },
    };

    updateItemInfoMutation.mutate(payload);
  };

  useEffect(() => {
    if (itemDetail?.id) {
      setItemInfoDraft({
        internalSku: itemDetail.internalSku ?? '',
        itemSku: itemDetail.itemSku ?? '',
        itemName: decodeHtml(itemDetail.itemName || ''),
      });
    }
  }, [itemDetail]);

  return (
    <Spin size={'large'} spinning={isLoadingUpload || updateItemInfoMutation.isPending}>
      <div className="item-detail">
        <div className="item-detail_back" onClick={handleBackButton}>
          <svg xmlns="http://www.w3.org/2000/svg" width={17} height={14} viewBox="0 0 17 14" fill="none">
            <path
              d="M1.40118 6.3009H15.4013C15.587 6.3009 15.765 6.37465 15.8963 6.50593C16.0276 6.63721 16.1013 6.81526 16.1013 7.00091C16.1013 7.18656 16.0276 7.36461 15.8963 7.49589C15.765 7.62717 15.587 7.70092 15.4013 7.70092H1.40118C1.21552 7.70092 1.03748 7.62717 0.906199 7.49589C0.774922 7.36461 0.701172 7.18656 0.701172 7.00091C0.701172 6.81526 0.774922 6.63721 0.906199 6.50593C1.03748 6.37465 1.21552 6.3009 1.40118 6.3009Z"
              fill="#514B4D"
            />
            <path
              d="M1.69107 7.00095L7.49692 12.8054C7.62836 12.9368 7.7022 13.1151 7.7022 13.301C7.7022 13.4869 7.62836 13.6652 7.49692 13.7966C7.36548 13.9281 7.1872 14.0019 7.00131 14.0019C6.81543 14.0019 6.63715 13.9281 6.50571 13.7966L0.205653 7.49655C0.140464 7.43153 0.0887436 7.35428 0.0534543 7.26924C0.018165 7.18419 0 7.09302 0 7.00095C0 6.90887 0.018165 6.8177 0.0534543 6.73266C0.0887436 6.64761 0.140464 6.57037 0.205653 6.50534L6.50571 0.205286C6.63715 0.0738434 6.81543 0 7.00131 0C7.1872 0 7.36548 0.0738434 7.49692 0.205286C7.62836 0.336728 7.7022 0.515003 7.7022 0.700891C7.7022 0.886778 7.62836 1.06505 7.49692 1.1965L1.69107 7.00095Z"
              fill="#514B4D"
            />
          </svg>
        </div>
        <div className="item-detail_container">
          <div className="item-detail_content">
            <div className="item-detail_content_name-info">
              <h6>{intl.formatMessage({ id: 'item.detail.title' })}</h6>
              {authUser?.role != AdminRole.OPERATION && (
                <div className="item-detail_content_name-info_wrap">
                  <p>
                    {intl.formatMessage({ id: 'item.detail.sellerName' })}: {itemDetail?.storageRequest?.user?.name}
                  </p>
                  <p>
                    {intl.formatMessage({ id: 'item.detail.sellerId' })}: {itemDetail?.storageRequest?.user?.userCode}
                  </p>
                </div>
              )}
            </div>
            <div className={`item-detail_content_top ${authUser?.role != AdminRole.OPERATION ? 'm-t-10' : 'm-t-24'}`}>
              <div className="operation-head">
                {renderStatusItem}
                {authUser?.role == AdminRole.OPERATION && (
                  <div className="icon">
                    {isEditItemInfo ? (
                      <>
                        <span onClick={handleCancelEditItemInfo} className="cursor-pointer m-l-0">
                          <SvgIconX />
                        </span>
                        <span
                          onClick={handleSaveItemInfo}
                          className={`cursor-pointer m-l-12 ${updateItemInfoMutation.isPending ? 'disabled' : ''}`}
                        >
                          <SvgIconCheck />
                        </span>
                      </>
                    ) : (
                      <span onClick={handleStartEditItemInfo} className="cursor-pointer">
                        <SvgIconEdit />
                      </span>
                    )}
                  </div>
                )}
              </div>
              <div className="item-detail_content_top_button-wrap">
                {renderButtonRevert}
                {renderButtonCancel}
              </div>
            </div>
            {authUser?.role !== AdminRole.OPERATION ? (
              <div className="item-detail_content_info-product">
                <div className="item-detail_content_info-product_table">
                  <div className="item-detail_content_info-product_table_left">
                    <div className="item-detail_content_info-product-img">
                      <img
                        src={
                          itemDetail?.ebayReturns?.ebayItemImage
                            ? resizeImageItemEbay(itemDetail?.ebayReturns?.ebayItemImage, 500)
                            : itemDetail?.preview?.source
                              ? Helper.getSourceFile(itemDetail?.preview?.source)
                              : null
                        }
                        alt=""
                      />
                    </div>
                    <div className="list">
                      <div className="title">
                        <span>返送情報</span>
                      </div>
                      <RowDetail
                        label="返品バイヤー名"
                        value={itemDetail?.ebayReturns?.ebayBuyerId ?? itemDetail?.storageRequest?.shipFromName}
                      />
                      <RowDetail
                        label="追跡番号"
                        value={renderTrackingNumber()}
                        action={renderAction()}
                        underline
                        isLink
                        href={itemDetail?.storageRequest?.shippoShippingLabel?.trackingUrlProvider}
                      />
                      <RowDetail
                        label="到着日"
                        value={
                          itemDetail?.storageRequest?.status === STATUS_ITEM_MANAGEMENT.CANCELED
                            ? ''
                            : renderReturnDeliveredDate()
                        }
                      />
                    </div>
                    <div className="list">
                      <div className="title">
                        <span>保管情報</span>
                      </div>
                      <RowDetail
                        label="保管期間（通算）"
                        value={itemDetail?.storageRange ? itemDetail?.storageRange + '日' : ''}
                      />
                      <RowDetail
                        label="保管期間（先月）"
                        value={numOfDayStorageFeeOfLastMonth ? numOfDayStorageFeeOfLastMonth + '日' : ''}
                      />
                      <RowDetail
                        label="保管期間（今月）"
                        value={numOfDayStorageFeeOfThisMonth !== null ? `${numOfDayStorageFeeOfThisMonth}日` : ''}
                      />
                      <RowDetail label="保管場所コード" value={itemDetail?.storageItemRack?.rack?.code} />
                    </div>
                  </div>
                  <div className="item-detail_content_info-product_table_right">
                    <div className="list">
                      <div className="title">
                        <span>商品情報</span>
                        {authUser?.role == AdminRole.ADMIN && (
                          <div className="icon">
                            {isEditItemInfo ? (
                              <>
                                <span onClick={handleCancelEditItemInfo} className="cursor-pointer m-l-0">
                                  <SvgIconX />
                                </span>
                                <span
                                  onClick={handleSaveItemInfo}
                                  className={`cursor-pointer ${updateItemInfoMutation.isPending ? 'disabled' : ''}`}
                                >
                                  <SvgIconCheck />
                                </span>
                              </>
                            ) : (
                              <span onClick={handleStartEditItemInfo} className="cursor-pointer">
                                <SvgIconEdit />
                              </span>
                            )}
                          </div>
                        )}
                      </div>
                      <RowDetail
                        label="BayPack管理番号"
                        value={
                          isEditItemInfo &&
                          !['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JNE', 'JLY', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'].some(
                            (month) => itemDetail?.internalSku.includes(month),
                          ) ? (
                            <CustomInput
                              value={itemInfoDraft.internalSku}
                              onChange={(e) => setItemInfoDraft((prev) => ({ ...prev, internalSku: e.target.value }))}
                            />
                          ) : (
                            itemDetail?.internalSku
                          )
                        }
                      />

                      <RowDetail
                        label="セラーSKU"
                        value={
                          isEditItemInfo ? (
                            <CustomInput
                              value={itemInfoDraft.itemSku}
                              onChange={(e) => setItemInfoDraft((prev) => ({ ...prev, itemSku: e.target.value }))}
                            />
                          ) : (
                            itemDetail?.itemSku
                          )
                        }
                      />

                      <RowDetail
                        label="商品名"
                        value={
                          isEditItemInfo ? (
                            <CustomInput
                              value={itemInfoDraft.itemName}
                              onChange={(e) => setItemInfoDraft((prev) => ({ ...prev, itemName: e.target.value }))}
                            />
                          ) : (
                            decodeHtml(itemDetail?.itemName || '')
                          )
                        }
                        isLink={!isEditItemInfo && !!itemDetail?.ebayReturns?.ebayItemId}
                        href={
                          !isEditItemInfo && itemDetail?.ebayReturns?.ebayItemId
                            ? getLinkItemEbayNavigate(itemDetail?.ebayReturns?.ebayItemId)
                            : undefined
                        }
                        underline={!isEditItemInfo && !!itemDetail?.ebayReturns?.ebayItemId}
                      />

                      <RowDetail
                        label="申告価格"
                        value={itemDetail?.itemPrice ? `$${Number(itemDetail?.itemPrice.toFixed(2))}` : ''}
                      />
                      <RowDetail
                        label="販売コンディション"
                        value={
                          itemDetail?.ebayReturns?.conditionDisplayName
                            ? itemDetail?.ebayReturns?.conditionDisplayName
                            : ''
                        }
                      />
                    </div>
                    <div className="list">
                      <div className="title">
                        <span>発送情報</span>
                      </div>
                      <RowDetail
                        label="販売バイヤー名"
                        value={
                          itemDetail?.shipToBuyerItem?.orderBuyerId &&
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest &&
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.status !== STATUS_ITEM_MANAGEMENT.CANCELED
                            ? itemDetail?.shipToBuyerItem?.orderBuyerId
                            : ''
                        }
                      />
                      <RowDetail
                        label="追跡番号"
                        underline
                        className="remove-flex"
                        isLink
                        href={itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingUrlProvider}
                        value={
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingNumber
                            ? `${itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingNumber}`
                            : ''
                        }
                        print={
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingNumber ? (
                            <span onClick={handlePrintTrackingShipToBuyer} className="cursor-pointer">
                              <PrintIcon />
                            </span>
                          ) : (
                            ''
                          )
                        }
                      />
                      <RowDetail
                        label="発送期限"
                        value={
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shipByDate
                            ? moment(itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shipByDate)
                                .tz(AmericaTimezone)
                                .format(`YYYY/MM/DD HH:mm z`)
                            : ''
                        }
                      />
                      <RowDetail
                        label="発送日"
                        value={
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippedAt
                            ? moment(itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippedAt)
                                .tz(AmericaTimezone)
                                .format(TIME_FORMAT.DATE('/'))
                            : ''
                        }
                      />
                    </div>
                    <div className="list">
                      <div className="title">
                        <span>料金情報</span>
                      </div>
                      <div className="item-detail_content_info-product_table_right_row">
                        <div className="item-detail_content_info-product_table_right_row_item">
                          <div className="item-detail_content_info-product_table_right_row_left">
                            <p>返送送料</p>
                            <span>:</span>
                          </div>
                          <div className="item-detail_content_info-product_table_right_row_right">
                            {itemDetail?.storageRequest?.shipFee
                              ? `$${Number(itemDetail?.storageRequest?.shipFee).toFixed(2)}${itemDetail?.storageRequest?.storageItems?.length > 1 ? `/${itemDetail?.storageRequest?.storageItems?.length}商品` : ''}`
                              : ''}
                          </div>
                        </div>
                        {itemDetail?.storageRequest?.realShipFee &&
                        itemDetail?.storageRequest?.realShipFee > itemDetail?.storageRequest?.shipFee ? (
                          <div className="item-detail_content_info-product_table_right_row_item">
                            <div className="item-detail_content_info-product_table_right_row_left">
                              <div className="item-detail_content_info-product_table_right_row_left_text">
                                追加返送送料
                                <div className="item-detail_content_info-product_table_right_row_left_text_des">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="item-detail_content_info-product_table_right_row_left_text_des_button"
                                    onClick={() => handleButtonClick(1)}
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M7.41667 12.0927L7.37933 8H5.95833V6.83333H8.7595L8.7945 10.926H10.1V12.0927H7.41667ZM7.125 4.857C7.11665 4.61002 7.20305 4.36919 7.3665 4.18383C7.52672 4.00494 7.75617 3.91589 8.05483 3.91667C8.3535 3.91667 8.5845 4.00611 8.74783 4.185C8.91117 4.36311 8.99244 4.58711 8.99167 4.857C8.99167 5.123 8.91 5.34389 8.74667 5.51967C8.58333 5.69544 8.35272 5.78333 8.05483 5.78333C7.75694 5.78333 7.5275 5.69544 7.3665 5.51967C7.20243 5.33887 7.11573 5.10097 7.125 4.857ZM8 13.8333C9.5471 13.8333 11.0308 13.2188 12.1248 12.1248C13.2188 11.0308 13.8333 9.5471 13.8333 8C13.8333 6.4529 13.2188 4.96917 12.1248 3.87521C11.0308 2.78125 9.5471 2.16667 8 2.16667C6.4529 2.16667 4.96917 2.78125 3.87521 3.87521C2.78125 4.96917 2.16667 6.4529 2.16667 8C2.16667 9.5471 2.78125 11.0308 3.87521 12.1248C4.96917 13.2188 6.4529 13.8333 8 13.8333ZM8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.8295 1 8.91925 1 8C1 7.08075 1.18106 6.1705 1.53284 5.32122C1.88463 4.47194 2.40024 3.70026 3.05025 3.05025C3.70026 2.40024 4.47194 1.88463 5.32122 1.53284C6.1705 1.18106 7.08075 1 8 1C9.85651 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85651 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85651 15 8 15Z"
                                      fill="#514B4D"
                                    />
                                  </svg>
                                  <div
                                    ref={popupRef}
                                    className={`popup-content item-detail_content_info-product_table_right_row_left_text_des_popup ${
                                      activePopup === 1 ? 'show' : ''
                                    }`}
                                  >
                                    BayPack拠点に到着した際の梱包サイズが、新規依頼時に申告された重量・サイズよりも大きかったため、追加の送料がかかっています
                                  </div>
                                </div>
                              </div>

                              <span>:</span>
                            </div>
                            <div className="item-detail_content_info-product_table_right_row_right">
                              {itemDetail?.storageRequest?.realShipFee &&
                              itemDetail?.storageRequest?.realShipFee > itemDetail?.storageRequest?.shipFee
                                ? `$${Number((itemDetail?.storageRequest?.realShipFee - itemDetail?.storageRequest?.shipFee).toFixed(2))}${itemDetail?.storageRequest?.storageItems?.length > 1 ? `/${itemDetail?.storageRequest?.storageItems?.length}商品` : ''}`
                                : ''}
                            </div>
                          </div>
                        ) : (
                          ''
                        )}
                      </div>
                      <div className="item-detail_content_info-product_table_right_row">
                        <div className="item-detail_content_info-product_table_right_row_item">
                          <div className="item-detail_content_info-product_table_right_row_left">
                            <p>利用手数料</p>
                            <span>:</span>
                          </div>
                          <div className="item-detail_content_info-product_table_right_row_right">
                            $
                            {itemDetail?.baseFee
                              ? (
                                  itemDetail?.baseFee *
                                  (itemDetail?.storageRequest?.appliedCouponRate
                                    ? (100 - itemDetail?.storageRequest?.appliedCouponRate) / 100
                                    : 1)
                                ).toFixed(2)
                              : itemDetail?.storageRequest?.baseFee
                                ? (itemDetail?.storageRequest?.baseFee * itemDetail?.storageRequest?.appliedCouponRate
                                    ? (100 - itemDetail?.storageRequest?.appliedCouponRate) / 100
                                    : 1
                                  ).toFixed(2)
                                : 0}
                          </div>
                        </div>
                        {itemDetail?.realBaseFee && getDiffFee(itemDetail) && (
                          <div className="item-detail_content_info-product_table_right_row_item">
                            <div className="item-detail_content_info-product_table_right_row_left">
                              <div className="item-detail_content_info-product_table_right_row_left_text">
                                追加利用手数料
                                <div className="item-detail_content_info-product_table_right_row_left_text_des">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    className="item-detail_content_info-product_table_right_row_left_text_des_button"
                                    onClick={() => handleButtonClick(2)}
                                  >
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M7.41667 12.0927L7.37933 8H5.95833V6.83333H8.7595L8.7945 10.926H10.1V12.0927H7.41667ZM7.125 4.857C7.11665 4.61002 7.20305 4.36919 7.3665 4.18383C7.52672 4.00494 7.75617 3.91589 8.05483 3.91667C8.3535 3.91667 8.5845 4.00611 8.74783 4.185C8.91117 4.36311 8.99244 4.58711 8.99167 4.857C8.99167 5.123 8.91 5.34389 8.74667 5.51967C8.58333 5.69544 8.35272 5.78333 8.05483 5.78333C7.75694 5.78333 7.5275 5.69544 7.3665 5.51967C7.20243 5.33887 7.11573 5.10097 7.125 4.857ZM8 13.8333C9.5471 13.8333 11.0308 13.2188 12.1248 12.1248C13.2188 11.0308 13.8333 9.5471 13.8333 8C13.8333 6.4529 13.2188 4.96917 12.1248 3.87521C11.0308 2.78125 9.5471 2.16667 8 2.16667C6.4529 2.16667 4.96917 2.78125 3.87521 3.87521C2.78125 4.96917 2.16667 6.4529 2.16667 8C2.16667 9.5471 2.78125 11.0308 3.87521 12.1248C4.96917 13.2188 6.4529 13.8333 8 13.8333ZM8 15C7.08075 15 6.1705 14.8189 5.32122 14.4672C4.47194 14.1154 3.70026 13.5998 3.05025 12.9497C2.40024 12.2997 1.88463 11.5281 1.53284 10.6788C1.18106 9.8295 1 8.91925 1 8C1 7.08075 1.18106 6.1705 1.53284 5.32122C1.88463 4.47194 2.40024 3.70026 3.05025 3.05025C3.70026 2.40024 4.47194 1.88463 5.32122 1.53284C6.1705 1.18106 7.08075 1 8 1C9.85651 1 11.637 1.7375 12.9497 3.05025C14.2625 4.36301 15 6.14348 15 8C15 9.85651 14.2625 11.637 12.9497 12.9497C11.637 14.2625 9.85651 15 8 15Z"
                                      fill="#514B4D"
                                    />
                                  </svg>
                                  <div
                                    ref={popupRef}
                                    className={`popup-content item-detail_content_info-product_table_right_row_left_text_des_popup ${
                                      activePopup === 2 ? 'show' : ''
                                    }`}
                                  >
                                    返送依頼時に申告された<br></br>
                                    重量・サイズよりも大きかったため、<br></br>
                                    追加の送料がかかっています
                                  </div>
                                </div>
                              </div>
                              <span>:</span>
                            </div>
                            <div className="item-detail_content_info-product_table_right_row_right">
                              {getDiffFee(itemDetail) ?? ''}
                            </div>
                          </div>
                        )}
                        {/* Ô bên phải trống (không có 追加利用手数料) → 特別配送費用 nằm luôn ở đây */}
                        {oversizeFeeTotal > 0 && !(itemDetail?.realBaseFee && getDiffFee(itemDetail))
                          ? renderOversizeFeeItem()
                          : ''}
                      </div>
                      {/* Ô bên phải đã có 追加利用手数料 → xếp 特別配送費用 ngay dưới, cùng cột phải */}
                      {oversizeFeeTotal > 0 && itemDetail?.realBaseFee && getDiffFee(itemDetail) ? (
                        <div className="item-detail_content_info-product_table_right_row">
                          <div className="item-detail_content_info-product_table_right_row_item" />
                          {renderOversizeFeeItem()}
                        </div>
                      ) : (
                        ''
                      )}
                      <RowDetail
                        label="商品保管料（通算）"
                        value={renderTotalStorageFee ? renderTotalStorageFee : ''}
                      />
                      <RowDetail
                        label="商品保管料（先月）"
                        value={renderStorageFeeOfLastMonth ? renderStorageFeeOfLastMonth : ''}
                      />
                      <RowDetail
                        label="商品保管料（今月）"
                        value={renderStorageFeeOfThisMonth ? renderStorageFeeOfThisMonth : ''}
                      />
                      <RowDetail
                        label="発送送料"
                        value={
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shipFee
                            ? `$${Number(itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shipFee.toFixed(2))}`
                            : ''
                        }
                      />
                      <RowDetail
                        label="廃棄金額"
                        value={
                          itemDetail?.disposalRequest?.chargeAmount
                            ? `$${Number(itemDetail?.disposalRequest?.chargeAmount.toFixed(2))}`
                            : ''
                        }
                      />
                      <RowDetail
                        label="オプション利用料"
                        value={totalOptionFee ? `$${totalOptionFee.toFixed(2)}` : ''}
                      />

                      {renderSpecialFeeSection}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="item-detail_content_info-product">
                <div className="item-detail_content_info-product_table for-operation-table">
                  <div className="item-detail_content_info-product_table_left for-operation-left">
                    <div className="item-detail_content_info-product-img for-operation-img">
                      <img
                        src={
                          itemDetail?.ebayReturns?.ebayItemImage
                            ? resizeImageItemEbay(itemDetail?.ebayReturns?.ebayItemImage, 500)
                            : itemDetail?.preview?.source
                              ? Helper.getSourceFile(itemDetail?.preview?.source)
                              : null
                        }
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="item-detail_content_info-product_table_right">
                    <div className="list for-operation-list">
                      <div className="item-detail_content_info-product_table_left_row">
                        <div className="item-detail_content_info-product_table_left_row_left">
                          <p>{intl.formatMessage({ id: 'item.detail.bayPackControlNumber' })}</p>
                          <span>:</span>
                        </div>
                        <div className="item-detail_content_info-product_table_left_row_right">
                          {isEditItemInfo &&
                          !['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JNE', 'JLY', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'].some(
                            (month) => itemDetail?.internalSku.includes(month),
                          ) ? (
                            <CustomInput
                              value={itemInfoDraft.internalSku}
                              onChange={(e) => setItemInfoDraft((prev) => ({ ...prev, internalSku: e.target.value }))}
                            />
                          ) : (
                            <>
                              {itemDetail?.internalSku}
                              <Spin spinning={loadingPrintSku}>
                                <span onClick={handlePrintSKU} className="cursor-pointer">
                                  <PrintIcon />
                                </span>
                              </Spin>
                            </>
                          )}
                        </div>
                      </div>

                      <RowDetail
                        label="セラーSKU"
                        value={
                          isEditItemInfo ? (
                            <CustomInput
                              value={itemInfoDraft.itemSku}
                              onChange={(e) => setItemInfoDraft((prev) => ({ ...prev, itemSku: e.target.value }))}
                            />
                          ) : (
                            itemDetail?.itemSku
                          )
                        }
                      />

                      <RowDetail
                        label="商品名"
                        value={
                          isEditItemInfo ? (
                            <CustomInput
                              value={itemInfoDraft.itemName}
                              onChange={(e) => setItemInfoDraft((prev) => ({ ...prev, itemName: e.target.value }))}
                            />
                          ) : (
                            decodeHtml(itemDetail?.itemName || '')
                          )
                        }
                        isLink={!isEditItemInfo && !!itemDetail?.ebayReturns?.ebayItemId}
                        href={
                          !isEditItemInfo && itemDetail?.ebayReturns?.ebayItemId
                            ? getLinkItemEbayNavigate(itemDetail?.ebayReturns?.ebayItemId)
                            : undefined
                        }
                        underline={!isEditItemInfo && !!itemDetail?.ebayReturns?.ebayItemId}
                      />

                      <RowDetail
                        label="販売コンディション"
                        value={
                          itemDetail?.ebayReturns?.conditionDisplayName
                            ? itemDetail?.ebayReturns?.conditionDisplayName
                            : ''
                        }
                      />
                      <RowDetail label="保管場所コード" value={itemDetail?.storageItemRack?.rack?.code} />
                      <RowDetail
                        label="発送期限"
                        value={
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shipByDate
                            ? moment(itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shipByDate)
                                .tz(AmericaTimezone)
                                .format(`YYYY/MM/DD HH:mm z`)
                            : ''
                        }
                      />
                      <RowDetail
                        label="追跡番号（返送）"
                        value={renderTrackingNumber()}
                        isLink
                        underline
                        className="remove-flex"
                        href={itemDetail?.storageRequest?.shippoShippingLabel?.trackingUrlProvider}
                        print={
                          renderTrackingNumber() ? (
                            <span onClick={handlePrintTrackingNumber} className="cursor-pointer">
                              <PrintIcon />
                            </span>
                          ) : (
                            ''
                          )
                        }
                      />
                      <RowDetail
                        label="追跡番号（発送）"
                        underline
                        className="remove-flex"
                        isLink
                        href={itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingUrlProvider}
                        value={
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingNumber
                            ? `${itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingNumber}`
                            : ''
                        }
                        print={
                          itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.shippoShippingLabel?.trackingNumber ? (
                            <span onClick={handlePrintTrackingShipToBuyer} className="cursor-pointer">
                              <PrintIcon />
                            </span>
                          ) : (
                            ''
                          )
                        }
                      />
                      {renderSpecialFeeSection}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <UploadMedia
              statusUploadFiles={statusUploadFiles}
              formUploadByStatus={formUploadByStatus}
              itemDetail={itemDetail}
              renderTakePhotoRequest={renderTakePhotoRequest}
              previewSender={previewSender}
              renderListPhoto={renderListPhoto}
              renderListVideo={renderListVideo}
              visibleSender={visibleSender}
              setPreviewSender={setPreviewSender}
              setStatusUploadFiles={setStatusUploadFiles}
              status={statusItem}
              setIsLoadingUploadMedia={setIsLoadingUploadMedia}
              isLoadingUploadMedia={isLoadingUploadMedia}
            />
            <div className="item-detail_content_manager-comment">
              <h6 className="item-detail_content_manager-comment_title">
                {intl.formatMessage({ id: 'item.detail.ourComment' })}
              </h6>
              <TextArea
                autoSize={true}
                value={focusComment.staffComment}
                onChange={({ target: { value } }) => {
                  setFocusComment({ ...focusComment, staffComment: value });
                }}
                onClick={() => setFocusComment({ ...focusComment, open: true })}
              />
              {focusComment.open ? (
                <div className="item-detail_content_manager-comment_btn-group">
                  <button onClick={() => setFocusComment({ open: false, staffComment: itemDetail.staffComment })}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M15 5L5 15M5 5L15 15"
                        stroke="#514B4D"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                  <button
                    onClick={() =>
                      editStaffComment.mutate({ staffComment: focusComment.staffComment, storageItemId: itemDetail.id })
                    }
                  >
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M3.4375 10.9375L7.8125 15.3125L16.5625 5.9375"
                        stroke="#514B4D"
                        stroke-width="1.875"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              ) : null}
              {editStaffComment.isPending ? (
                <div className="loading">
                  <Spin />
                </div>
              ) : null}
            </div>
            <div className="item-detail_content_param">
              {/* DECLARED SIZE */}
              <div className="item-detail_content_param_size">
                <h6 className="item-detail_content_param_size_title">
                  {intl.formatMessage({ id: 'item.detail.sizeDeclaredAtTimeOfRequest' })}
                </h6>

                <div className="item-detail_content_param_size_list">
                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.length' })}
                    valueReadonly={
                      itemDetail?.storageRequest?.reportLength != null ? (
                        <InchDisplay cm={itemDetail.storageRequest.reportLength} rounding="ceil" />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.width' })}
                    valueReadonly={
                      itemDetail?.storageRequest?.reportWidth != null ? (
                        <InchDisplay cm={itemDetail.storageRequest.reportWidth} rounding="ceil" />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.height' })}
                    valueReadonly={
                      itemDetail?.storageRequest?.reportHeight != null ? (
                        <InchDisplay cm={itemDetail.storageRequest.reportHeight} rounding="ceil" />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.packingWeight' })}
                    valueReadonly={
                      itemDetail?.storageRequest?.reportWeight != null ? (
                        <>
                          <span className="value-number">{itemDetail.storageRequest.reportWeight}</span>
                          <span className="value-unit">kg</span>
                        </>
                      ) : (
                        <span className="value-unit">kg</span>
                      )
                    }
                  />
                </div>
              </div>

              {/* ARRIVAL SIZE */}
              <div className="item-detail_content_param_size">
                <h6 className="item-detail_content_param_size_title">
                  {intl.formatMessage({ id: 'item.detail.arrivalSize' })}
                </h6>

                {/* Chỉ hiển thị 2 checkbox phụ phí quá khổ khi seller trả phí; buyer pay thì ẩn. */}
                {itemDetail?.storageRequest?.sellerPayFlag && (
                  <div className="item-detail_content_param_size_flags">
                    <Checkbox
                      checked={!!itemDetailRealVol.isDeformed}
                      disabled={isOversizeFlagDisabled('isDeformed')}
                      onChange={(e) => handleToggleOversizeFlag('isDeformed', e.target.checked)}
                    >
                      {intl.formatMessage({ id: 'item.detail.isDeformed' })}
                    </Checkbox>
                    <Checkbox
                      checked={!!itemDetailRealVol.isNonCarton}
                      disabled={isOversizeFlagDisabled('isNonCarton')}
                      onChange={(e) => handleToggleOversizeFlag('isNonCarton', e.target.checked)}
                    >
                      {intl.formatMessage({ id: 'item.detail.isNonCarton' })}
                    </Checkbox>
                  </div>
                )}

                <div className="item-detail_content_param_size_list">
                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.length' })}
                    editable={!itemDetail?.storageRequest?.realLength && !isDisableInput}
                    valueReadonly={
                      itemDetailRealVol.realLength != null ? (
                        <InchDisplay cm={itemDetailRealVol.realLength ?? 0} />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                    inputNode={
                      <>
                        <QuarterInchInput
                          valueCm={itemDetailRealVol.realLength}
                          onChangeCm={(cm) => {
                            if (cm == null || !Number.isFinite(cm) || cm <= 0) {
                              setItemDetailRealVol((prev) => ({ ...prev, realLength: undefined }));
                              setRealError((prev) => ({ ...prev, length: false }));
                              return;
                            }

                            if (!validateMaxInch(cm, 'length', 'real')) {
                              return;
                            }

                            setItemDetailRealVol((prev) => ({ ...prev, realLength: cm }));
                            setRealError((prev) => ({ ...prev, length: false }));
                          }}
                          disabled={!!itemDetail?.storageRequest?.realLength || isDisableInput}
                          className={realError.length ? 'item-detail__input-error' : ''}
                        />

                        <label>inch</label>
                      </>
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.width' })}
                    editable={!itemDetail?.storageRequest?.realWidth && !isDisableInput}
                    valueReadonly={
                      itemDetailRealVol.realWidth != null ? (
                        <InchDisplay cm={itemDetailRealVol.realWidth ?? 0} rounding="ceil" />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                    inputNode={
                      <>
                        <QuarterInchInput
                          valueCm={itemDetailRealVol.realWidth}
                          onChangeCm={(cm) => {
                            if (cm == null || !Number.isFinite(cm) || cm <= 0) {
                              setItemDetailRealVol((prev) => ({ ...prev, realWidth: undefined }));
                              setRealError((prev) => ({ ...prev, width: false }));
                              return;
                            }

                            if (!validateMaxInch(cm, 'width', 'real')) {
                              return;
                            }

                            setItemDetailRealVol((prev) => ({ ...prev, realWidth: cm }));
                            setRealError((prev) => ({ ...prev, width: false }));
                          }}
                          disabled={isDisableInput || !!itemDetail?.storageRequest?.realWidth}
                          className={realError.width ? 'item-detail__input-error' : ''}
                        />

                        <label>inch</label>
                      </>
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.height' })}
                    labelClassName="label-has-input"
                    editable={!itemDetail?.storageRequest?.realHeight && !isDisableInput}
                    valueReadonly={
                      itemDetailRealVol.realHeight != null ? (
                        <InchDisplay cm={itemDetailRealVol.realHeight ?? 0} rounding="ceil" />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                    inputNode={
                      <>
                        <QuarterInchInput
                          valueCm={itemDetailRealVol.realHeight}
                          onChangeCm={(cm) => {
                            if (cm == null || !Number.isFinite(cm) || cm <= 0) {
                              setItemDetailRealVol((prev) => ({ ...prev, realHeight: undefined }));
                              setRealError((prev) => ({ ...prev, height: false }));
                              return;
                            }

                            if (!validateMaxInch(cm, 'height', 'real')) {
                              return;
                            }

                            setItemDetailRealVol((prev) => ({ ...prev, realHeight: cm }));
                            setRealError((prev) => ({ ...prev, height: false }));
                          }}
                          disabled={isDisableInput || Boolean(itemDetail?.storageRequest?.realHeight)}
                          className={realError.height ? 'item-detail__input-error' : ''}
                        />

                        <label>inch</label>
                      </>
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.arrivalWeight' })}
                    labelClassName="label-has-input"
                    editable={!itemDetail?.storageRequest?.realWeight && !isDisableInput}
                    valueReadonly={
                      itemDetailRealVol.realWeight != null ? (
                        <>
                          <span className="value-number">{itemDetailRealVol.realWeight}</span>
                          <span className="value-unit">kg</span>
                        </>
                      ) : (
                        <span className="value-unit">kg</span>
                      )
                    }
                    inputNode={
                      <>
                        <input
                          type="number"
                          className={`item-detail__kg-input ${realError.weight ? 'item-detail__input-error' : ''}`}
                          value={itemDetailRealVol.realWeight ?? ''}
                          onChange={(e) => {
                            let v = e.target.value;

                            if (!v) {
                              setItemDetailRealVol((prev) => ({
                                ...prev,
                                realWeight: undefined,
                              }));
                              setRealError((prev) => ({ ...prev, weight: false }));
                              return;
                            }

                            if (v.includes('.')) {
                              const [decimalPart] = v.split('.');
                              if (decimalPart.length > 2) {
                                NotificationError({
                                  content: '小数点以下は2桁まで入力してください。',
                                });
                                setRealError((prev) => ({ ...prev, weight: true }));
                              } else {
                                setRealError((prev) => ({ ...prev, weight: false }));
                              }
                            } else {
                              setRealError((prev) => ({ ...prev, weight: false }));
                            }

                            setItemDetailRealVol((prev) => ({
                              ...prev,
                              realWeight: +v,
                            }));
                          }}
                          disabled={Boolean(itemDetail?.storageRequest?.realWeight) || isDisableInput}
                        />

                        <label>kg</label>
                      </>
                    }
                  />
                </div>
              </div>
              {/* STORAGE SIZE */}
              <div className="item-detail_content_param_size">
                <h6 className="item-detail_content_param_size_title">
                  {intl.formatMessage({ id: 'item.detail.storageSize' })}
                </h6>

                <div className="item-detail_content_param_size_list">
                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.length' })}
                    labelClassName="label-has-input"
                    editable={
                      (!isDisableInput && !itemDetail?.storageWeight) ||
                      (editDimensionStorage && !editDimensionStorageApi.isPending)
                    }
                    valueReadonly={
                      itemDetailStorageVol.storageLength != null ? (
                        <InchDisplay cm={itemDetailStorageVol.storageLength ?? 0} rounding="ceil" />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                    inputNode={
                      <>
                        <QuarterInchInput
                          valueCm={itemDetailStorageVol.storageLength}
                          onChangeCm={(cm) => {
                            if (cm == null || !Number.isFinite(cm) || cm <= 0) {
                              setItemDetailStorageVol((prev) => ({ ...prev, storageLength: undefined }));
                              setStorageError((prev) => ({ ...prev, length: false }));
                              return;
                            }

                            if (!validateMaxInch(cm, 'length', 'storage')) {
                              return;
                            }

                            setItemDetailStorageVol((prev) => ({ ...prev, storageLength: cm }));
                            setStorageError((prev) => ({ ...prev, length: false }));
                          }}
                          // disabled={!((!isDisableInput || editDimensionStorage) && !editDimensionStorageApi.isPending)}
                          className={storageError.length ? 'item-detail__input-error' : ''}
                        />

                        <label>inch</label>
                      </>
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.width' })}
                    labelClassName="label-has-input"
                    editable={
                      (!isDisableInput && !itemDetail?.storageWeight) ||
                      (editDimensionStorage && !editDimensionStorageApi.isPending)
                    }
                    valueReadonly={
                      itemDetailStorageVol.storageWidth != null ? (
                        <InchDisplay cm={itemDetailStorageVol.storageWidth ?? 0} rounding="ceil" />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                    inputNode={
                      <>
                        <QuarterInchInput
                          valueCm={itemDetailStorageVol.storageWidth}
                          onChangeCm={(cm) => {
                            if (cm == null || !Number.isFinite(cm) || cm <= 0) {
                              setItemDetailStorageVol((prev) => ({ ...prev, storageWidth: undefined }));
                              setStorageError((prev) => ({ ...prev, width: false }));
                              return;
                            }

                            if (!validateMaxInch(cm, 'width', 'storage')) {
                              return;
                            }

                            setItemDetailStorageVol((prev) => ({ ...prev, storageWidth: cm }));
                            setStorageError((prev) => ({ ...prev, width: false }));
                          }}
                          // disabled={!((!isDisableInput || editDimensionStorage) && !editDimensionStorageApi.isPending)}
                          className={storageError.width ? 'item-detail__input-error' : ''}
                        />

                        <label>inch</label>
                      </>
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.height' })}
                    labelClassName="label-has-input"
                    editable={
                      (!isDisableInput && !itemDetail?.storageWeight) ||
                      (editDimensionStorage && !editDimensionStorageApi.isPending)
                    }
                    valueReadonly={
                      itemDetailStorageVol.storageHeight != null ? (
                        <InchDisplay cm={itemDetailStorageVol.storageHeight ?? 0} rounding="ceil" />
                      ) : (
                        <span className="value-unit">inch</span>
                      )
                    }
                    inputNode={
                      <>
                        <QuarterInchInput
                          valueCm={itemDetailStorageVol.storageHeight}
                          onChangeCm={(cm) => {
                            if (cm == null || !Number.isFinite(cm) || cm <= 0) {
                              setItemDetailStorageVol((prev) => ({ ...prev, storageHeight: undefined }));
                              setStorageError((prev) => ({ ...prev, height: false }));
                              return;
                            }

                            if (!validateMaxInch(cm, 'height', 'storage')) {
                              return;
                            }

                            setItemDetailStorageVol((prev) => ({ ...prev, storageHeight: cm }));
                            setStorageError((prev) => ({ ...prev, height: false }));
                          }}
                          className={storageError.height ? 'item-detail__input-error' : ''}
                        />

                        <label>inch</label>
                      </>
                    }
                  />

                  <DimensionRow
                    label={intl.formatMessage({ id: 'item.detail.storageWeight' })}
                    labelClassName="label-has-input"
                    editable={
                      (!isDisableInput && !itemDetail?.storageWeight) ||
                      (editDimensionStorage && !editDimensionStorageApi.isPending)
                    }
                    valueReadonly={
                      itemDetailStorageVol?.storageWeight != null ? (
                        <>
                          <span className="value-number">{itemDetailStorageVol?.storageWeight}</span>
                          <span className="value-unit">kg</span>
                        </>
                      ) : (
                        <span className="value-unit">kg</span>
                      )
                    }
                    inputNode={
                      <>
                        <input
                          type="number"
                          className={`item-detail__kg-input ${storageError.weight ? 'item-detail__input-error' : ''}`}
                          value={itemDetailStorageVol?.storageWeight ?? ''}
                          onChange={(e) => {
                            let v = e.target.value;

                            if (!v) {
                              setItemDetailStorageVol((prev) => ({
                                ...prev,
                                storageWeight: undefined,
                              }));
                              setStorageError((prev) => ({ ...prev, weight: false }));
                              return;
                            }

                            if (v.includes('.')) {
                              const [decimalPart] = v.split('.');
                              if (decimalPart.length > 2) {
                                NotificationError({
                                  content: '小数点以下は2桁まで入力してください。',
                                });
                                setStorageError((prev) => ({ ...prev, weight: true }));
                              } else {
                                setStorageError((prev) => ({ ...prev, weight: false }));
                              }
                            } else {
                              setStorageError((prev) => ({ ...prev, weight: false }));
                            }

                            setItemDetailStorageVol((prev) => ({
                              ...prev,
                              storageWeight: +v,
                            }));
                          }}
                        />

                        <label>kg</label>
                      </>
                    }
                  />
                </div>

                {itemDetail?.storageWeight && (
                  <div className="edit-dimension-storage">
                    {editDimensionStorage ? (
                      <div className="edit-dimension-storage-btn-group">
                        <div className="btn-submit">
                          <ButtonAgree value="確定" onClick={onSubmitEditDimensionStorage} />
                          {editDimensionStorageApi.isPending && (
                            <div className="loading">
                              <Spin />
                            </div>
                          )}
                        </div>

                        <ButtonCancel
                          value={intl.formatMessage({ id: 'common.cancel' })}
                          onClick={onCancelEditDimensionStorage}
                        />
                      </div>
                    ) : (
                      <button className="edit-dimension-storage-btn" onClick={() => setEditDimensionStorage(true)}>
                        <SvgIconEditLarge />
                      </button>
                    )}
                  </div>
                )}
              </div>
              {/* Nút hành động chính (検品完了/登録/...) đặt cuối trang, sau khi nhập kích thước */}
              {handleViewButton(statusItem || '') !== '' && (
                <div className="item-detail_content_param_action">
                  <button
                    className="item-detail_content_top_button-wrap_shipping-request"
                    onClick={() => {
                      handleActionButton(statusItem || '');
                    }}
                  >
                    {intl.formatMessage({ id: `item.detail.${handleViewButton(statusItem || '')}` })}
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="item-detail_right">
            <div className="item-detail_feedback">
              <div className="item-detail_feedback_title">
                <div className="item-detail_feedback_title-left">
                  <h6>{intl.formatMessage({ id: 'item.detail.note.title-list' })}</h6>
                  <button className="btn-add" onClick={handleOpenRegisterNote}>
                    {intl.formatMessage({ id: 'common.add' })}
                  </button>
                </div>
                <button
                  className="btn-expand"
                  onClick={() => {
                    setExpandBox(!expandBox);
                  }}
                >
                  {intl.formatMessage({ id: !expandBox ? 'common.expand' : 'item.detail.close-note' })}
                </button>
              </div>
              <div className="item-detail_feedback_content ebay__scroll-bar-custom">{renderListNote}</div>
            </div>
            <ChatItem />
          </div>
        </div>
        <div className={`item-detail_cancel-modal ${activeModalCancel ? 'open' : ''}`}>
          <div className="item-detail_cancel-modal_overlay" onClick={handleCloseModalCancel}></div>
          <div className="item-detail_cancel-modal_body">
            <div className="item-detail_cancel-modal_body_text">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                  d="M12.5 16.462C12.6747 16.462 12.8207 16.403 12.938 16.285C13.056 16.167 13.115 16.0207 13.115 15.846C13.115 15.672 13.056 15.526 12.938 15.408C12.8207 15.29 12.6747 15.231 12.5 15.231C12.3253 15.231 12.1793 15.29 12.062 15.408C11.9447 15.526 11.8857 15.672 11.885 15.846C11.8843 16.02 11.9433 16.1663 12.062 16.285C12.1793 16.403 12.3253 16.462 12.5 16.462ZM12 13.154H13V7.154H12V13.154ZM12.503 21C11.259 21 10.089 20.764 8.993 20.292C7.89767 19.8193 6.94467 19.178 6.134 18.368C5.32333 17.558 4.68167 16.606 4.209 15.512C3.73633 14.418 3.5 13.2483 3.5 12.003C3.5 10.7577 3.736 9.58767 4.208 8.493C4.68 7.39833 5.32133 6.44533 6.132 5.634C6.94267 4.82267 7.89467 4.181 8.988 3.709C10.0813 3.237 11.251 3.00067 12.497 3C13.743 2.99933 14.913 3.23533 16.007 3.708C17.101 4.18067 18.054 4.822 18.866 5.632C19.678 6.442 20.3197 7.394 20.791 8.488C21.2623 9.582 21.4987 10.7517 21.5 11.997C21.5013 13.2423 21.2653 14.4123 20.792 15.507C20.3187 16.6017 19.6773 17.5547 18.868 18.366C18.0587 19.1773 17.1067 19.819 16.012 20.291C14.9173 20.763 13.7477 20.9993 12.503 21Z"
                  fill="#F43258"
                />
              </svg>
              <p>依頼をキャンセルしますか？</p>
            </div>
            <div className="item-detail_cancel-modal_body_button">
              <ButtonCancel value="いいえ" onClick={handleCloseModalCancel} />
              <ButtonAgree value="はい" />
            </div>
          </div>
        </div>
        <CustomConfirmModel
          isOpen={!!pendingCancelPhotoRequest}
          setIsOpen={() => setPendingCancelPhotoRequest(undefined)}
          idDataDetail={0}
          titleText="依頼をキャンセル"
          // 「キャンセルしますか？」mà nút lại là「キャンセル」thì khó hiểu → はい / いいえ (feedback KH 2026-10-05).
          cancelText={intl.formatMessage({ id: 'common.no' })}
          confirmText={intl.formatMessage({ id: 'common.yes' })}
          // Chỉ đóng bằng はい / いいえ / nút ×; bấm ra ngoài không đóng.
          maskClosable={false}
          keyboard={false}
          messageText={
            <span className="font-size-16 color-sub-title">
              この追加写真撮影依頼をキャンセルしますか？
              {/* Phí đã thu lúc tạo → hoàn sau khi trừ キャンセル料: nói rõ số tiền vì hoàn tiền không đảo ngược được. */}
              {!!pendingCancelPhotoRequest?.chargeAmount && (
                <>
                  <br />
                  {cancelRefundNote(Number(pendingCancelPhotoRequest.chargeAmount), cancellationRate ?? 0)}
                </>
              )}
            </span>
          }
          onFinish={() => {
            if (!pendingCancelPhotoRequest || cancelPhotoRequest.isPending) return;
            cancelPhotoRequest.mutate(pendingCancelPhotoRequest.id);
          }}
        />
        {activeAddPhoto.isShow && (
          <TakePhotoModal
            activeAddPhoto={activeAddPhoto}
            handleCloseAddPhoto={handleCloseAddPhoto}
            renderTextStatusPhotoRequest={renderTextStatusPhotoRequest}
            setActiveAddPhoto={setActiveAddPhoto}
          />
        )}
        <div className={`item-detail_register-note ${activeRegisterNote ? 'open' : ''}`}>
          <div className="item-detail_register-note_overlay" onClick={handleCloseRegisterNote}></div>
          <div className="item-detail_register-note_body">
            <h6 className="item-detail_register-note_body_title">
              {intl.formatMessage({ id: 'item.detail.note.title' })}
            </h6>
            <div className="item-detail_register-note_body_content">
              <FormWrap form={form}>
                <label htmlFor="">
                  {intl.formatMessage({ id: 'item.detail.note.content' })}
                  <span>*</span>
                </label>
                <Form.Item name="message" required rules={[{ required: true, message: '' }]}>
                  <CustomInputArea placeholder={intl.formatMessage({ id: 'chat-item.send' })} />
                </Form.Item>
              </FormWrap>

              {/* <textarea name="" id="" placeholder={'備考登録を入力'}></textarea> */}
            </div>
            <div className="item-detail_register-note_body_button-wrap">
              <ButtonCancel value={intl.formatMessage({ id: 'common.cancel' })} onClick={handleCloseRegisterNote} />
              <ButtonAgree value={intl.formatMessage({ id: 'common.registration' })} onClick={handleRegisterNote} />
            </div>
          </div>
        </div>
        <div className={`item-detail_note-item ${isEdit.isOpen ? 'open' : ''}`}>
          <div className="item-detail_note-item_overlay" onClick={handleCloseNoteItem}></div>
          <div className="item-detail_note-item_body">
            <h6 className="item-detail_note-item_body_title">メモ詳細</h6>
            <div className="item-detail_note-item_body_info">
              <div className="item-detail_note-item_body_info_name">
                <div className="include-img">
                  <img
                    src={Helper.getSourceFile(
                      isEdit.data?.staff?.avatar?.source || isEdit.data?.staff?.avatar?.preview,
                    )}
                    alt=""
                  />
                </div>
                <p className="font-size-14">{isEdit.data?.staff?.name ?? ''}</p>
              </div>
              <div className="item-detail_note-item_body_info_time font-size-14">
                登録日時：{moment(isEdit.data?.updatedAt).format(TIME_FORMAT.MESSAGE_TIME)}
              </div>
            </div>
            <div className="item-detail_note-item_body_content">
              <label htmlFor="">{intl.formatMessage({ id: 'item.detail.note.content' })}</label>
              <textarea
                name=""
                id=""
                value={isEdit.content || ''}
                onChange={(e) => {
                  const trimmedValue = e?.target?.value?.toString().trim();
                  setIsEdit({ ...isEdit, content: trimmedValue || '' });
                }}
                onKeyDown={(e) => {
                  if (e.code === 'Enter') {
                    e.preventDefault();
                    setIsEdit({ ...isEdit, content: isEdit.content + '\n' });
                  }
                }}
              ></textarea>
            </div>
            <div className="item-detail_note-item_body_button-wrap">
              <ButtonCancel value="閉じる" onClick={handleCloseNoteItem} />
              <ButtonAgree
                value={intl.formatMessage({ id: 'common.registration' })}
                onClick={() => handleSendEditNote(isEdit.id)}
              />
            </div>
          </div>
        </div>
        <div className={`item-detail_cancel-modal ${activeModalCancelRequest.isShow ? 'open' : ''}`}>
          <div className="item-detail_cancel-modal_overlay" onClick={handleCloseModalCancelRequest}></div>
          <div className="item-detail_cancel-modal_body">
            <div className="item-detail_cancel-modal_body_text">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                  d="M12.5 16.462C12.6747 16.462 12.8207 16.403 12.938 16.285C13.056 16.167 13.115 16.0207 13.115 15.846C13.115 15.672 13.056 15.526 12.938 15.408C12.8207 15.29 12.6747 15.231 12.5 15.231C12.3253 15.231 12.1793 15.29 12.062 15.408C11.9447 15.526 11.8857 15.672 11.885 15.846C11.8843 16.02 11.9433 16.1663 12.062 16.285C12.1793 16.403 12.3253 16.462 12.5 16.462ZM12 13.154H13V7.154H12V13.154ZM12.503 21C11.259 21 10.089 20.764 8.993 20.292C7.89767 19.8193 6.94467 19.178 6.134 18.368C5.32333 17.558 4.68167 16.606 4.209 15.512C3.73633 14.418 3.5 13.2483 3.5 12.003C3.5 10.7577 3.736 9.58767 4.208 8.493C4.68 7.39833 5.32133 6.44533 6.132 5.634C6.94267 4.82267 7.89467 4.181 8.988 3.709C10.0813 3.237 11.251 3.00067 12.497 3C13.743 2.99933 14.913 3.23533 16.007 3.708C17.101 4.18067 18.054 4.822 18.866 5.632C19.678 6.442 20.3197 7.394 20.791 8.488C21.2623 9.582 21.4987 10.7517 21.5 11.997C21.5013 13.2423 21.2653 14.4123 20.792 15.507C20.3187 16.6017 19.6773 17.5547 18.868 18.366C18.0587 19.1773 17.1067 19.819 16.012 20.291C14.9173 20.763 13.7477 20.9993 12.503 21Z"
                  fill="#F43258"
                />
              </svg>
              <p>{renderModalConfirmCancel}</p>
            </div>
            <div className="item-detail_cancel-modal_body_button">
              <ButtonCancel value={'いいえ'} onClick={handleCloseModalCancelRequest} />
              <ButtonAgree value={'はい'} onClick={handleActiveCancel} />
            </div>
          </div>
        </div>
        <div className={`item-detail_cancel-modal ${activeModalRevert ? 'open' : ''}`}>
          <div className="item-detail_cancel-modal_overlay" onClick={() => setActiveModalRevert(false)}></div>
          <div className="item-detail_cancel-modal_body">
            <div className="item-detail_cancel-modal_body_text">
              <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                <path
                  d="M12.5 16.462C12.6747 16.462 12.8207 16.403 12.938 16.285C13.056 16.167 13.115 16.0207 13.115 15.846C13.115 15.672 13.056 15.526 12.938 15.408C12.8207 15.29 12.6747 15.231 12.5 15.231C12.3253 15.231 12.1793 15.29 12.062 15.408C11.9447 15.526 11.8857 15.672 11.885 15.846C11.8843 16.02 11.9433 16.1663 12.062 16.285C12.1793 16.403 12.3253 16.462 12.5 16.462ZM12 13.154H13V7.154H12V13.154ZM12.503 21C11.259 21 10.089 20.764 8.993 20.292C7.89767 19.8193 6.94467 19.178 6.134 18.368C5.32333 17.558 4.68167 16.606 4.209 15.512C3.73633 14.418 3.5 13.2483 3.5 12.003C3.5 10.7577 3.736 9.58767 4.208 8.493C4.68 7.39833 5.32133 6.44533 6.132 5.634C6.94267 4.82267 7.89467 4.181 8.988 3.709C10.0813 3.237 11.251 3.00067 12.497 3C13.743 2.99933 14.913 3.23533 16.007 3.708C17.101 4.18067 18.054 4.822 18.866 5.632C19.678 6.442 20.3197 7.394 20.791 8.488C21.2623 9.582 21.4987 10.7517 21.5 11.997C21.5013 13.2423 21.2653 14.4123 20.792 15.507C20.3187 16.6017 19.6773 17.5547 18.868 18.366C18.0587 19.1773 17.1067 19.819 16.012 20.291C14.9173 20.763 13.7477 20.9993 12.503 21Z"
                  fill="#F43258"
                />
              </svg>
              <p>発送準備完了を取り消しますか？</p>
            </div>
            <div className="item-detail_cancel-modal_body_button">
              <ButtonCancel value={'いいえ'} onClick={() => setActiveModalRevert(false)} />
              <ButtonAgree
                value={'はい'}
                onClick={() => {
                  if (itemDetail?.shipToBuyerItem?.shipToBuyerRequest?.id) {
                    RevertPreparingDone(itemDetail.shipToBuyerItem.shipToBuyerRequest.id);
                  }
                  setActiveModalRevert(false);
                }}
              />
            </div>
          </div>
        </div>
        <Modal
          title=""
          closable={false}
          open={isOpen}
          className="item-detail__inputed-modal-container"
          centered={true}
          onCancel={() => setIsOpen(false)}
          closeIcon={<SvgCloseModalIcon />}
          footer={
            <div className="item-detail__inputed-button-container">
              <CustomCommonButton
                isCancelButton={true}
                buttonProps={{
                  className: 'item-detail__inputed-button-action',
                  onClick: () => setIsOpen(false),
                  block: true,
                }}
                content={intl.formatMessage({ id: 'common.cancel' })}
              />
              <CustomCommonButton
                isCancelButton={true}
                buttonProps={{
                  className: 'item-detail__inputed-button-action',
                  type: 'primary',
                  onClick: () => formUpdateItem.submit(),
                  block: true,
                  loading: updatePriceMutation.isPending || updatePriceMutation.isPending,
                }}
                content={intl.formatMessage({ id: 'common.submit' })}
              />
            </div>
          }
        >
          <FormWrap form={formUpdateItem} onFinish={onFinishUpdatePrice} onFinishFailed={onFinishFailedUpdatePrice}>
            <Form.Item
              name={'price'}
              className="item-detail__inputed-input-price"
              label={
                <p className="item-detail__inputed-input-label">
                  {intl.formatMessage({ id: 'item.detail.disposalAmount' })}
                  <span>*</span>
                </p>
              }
              required
              rules={[{ required: true, message: '' }]}
            >
              <Input prefix={<SvgDolarIcon />} type="number" />
            </Form.Item>
          </FormWrap>
        </Modal>
        <Modal
          title="保管時サイズ・重量を入力してください"
          closable={true}
          maskClosable={false}
          open={isOpenDisposalDims}
          centered={true}
          onCancel={() => setIsOpenDisposalDims(false)}
          closeIcon={<SvgCloseModalIcon />}
          className={'request-management__modal-shipping request-management__modal-shipping-multi'}
          footer={
            <div className="request-management__btn-container">
              <CustomCommonButton
                isCancelButton={true}
                buttonProps={{
                  className: 'request-management__btn-print request-management__btn-print--neutral',
                  onClick: () => setIsOpenDisposalDims(false),
                }}
                content={'閉じる'}
              />
              <CustomCommonButton
                isCancelButton={true}
                buttonProps={{
                  className: 'request-management__btn-cancel',
                  type: 'primary',
                  onClick: handleNextFromDisposalDims,
                }}
                content={'次へ進む'}
              />
            </div>
          }
        >
          {/* Bắt chước NGUYÊN bước dimension của popup ship-to-buyer gộp (requestManagement):
              cùng markup + class + component ô inch, để 2 luồng nhập size trông y hệt nhau. */}
          <div className="request-management__multi-dimension">
            <div className="request-management__multi-dimension-list">
              {(
                [
                  ['縦', 'length'],
                  ['横', 'width'],
                  ['高さ', 'height'],
                ] as const
              ).map(([label, key]) => (
                <div key={key} className="request-management__multi-dimension-item">
                  <label>{label}</label>
                  <RequestManagementQuarterInchInput
                    valueCm={disposalDims[key]}
                    onChangeCm={(cm) => {
                      setDisposalDims((prev) => ({ ...prev, [key]: cm > 0 ? cm : undefined }));
                      setDisposalDimsError((prev) => ({ ...prev, [key]: false }));
                    }}
                    className={disposalDimsError[key] ? 'request-management__input-error' : ''}
                    rounding="ceil"
                  />
                  <span className="unit">inch</span>
                </div>
              ))}
            </div>
            <div className="request-management__multi-dimension-list request-management__multi-dimension-list--weight">
              <div className="request-management__multi-dimension-item">
                <label>重量</label>
                <Input
                  type="number"
                  className={`request-management__kg-input ${disposalDimsError.weight ? 'request-management__input-error' : ''}`}
                  value={disposalWeightInput}
                  onChange={(e) => {
                    const raw = e.target.value;
                    setDisposalWeightInput(raw);
                    setDisposalDims((prev) => ({ ...prev, weight: raw ? Number(raw) : undefined }));
                    setDisposalDimsError((prev) => ({ ...prev, weight: false }));
                  }}
                />
                <span className="unit">kg</span>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          title=""
          closable={false}
          open={isOpenConfirm}
          className="item-detail__confirm-disposal"
          centered={true}
          onCancel={() => setIsOpenConfirm(false)}
          closeIcon={<SvgCloseModalIcon />}
          footer={null}
        >
          <div className="item-detail__confirm-disposal-title">
            <SvgWarningIcon />
            <p>{intl.formatMessage({ id: 'item.detail.confirmDisposal' })}</p>
          </div>
          <div className="item-detail__inputed-button-container">
            <CustomCommonButton
              isCancelButton={true}
              buttonProps={{
                className: 'item-detail__inputed-button-action',
                onClick: () => setIsOpenConfirm(false),
                block: true,
              }}
              content={intl.formatMessage({ id: 'common.cancel' })}
            />
            <CustomCommonButton
              isCancelButton={true}
              buttonProps={{
                className: 'item-detail__inputed-button-action',
                type: 'primary',
                onClick: () => confirmDisposal(),
                block: true,
                loading: completedDisposalMutation.isPending || completedDisposalMutation.isPending,
              }}
              content={intl.formatMessage({ id: 'common.yes' })}
            />
          </div>
        </Modal>
        <Modal
          title=""
          closable={false}
          open={isOpenCheck}
          className="item-detail__percent-diff"
          centered={true}
          onCancel={() => setIsOpenCheck(false)}
          closeIcon={<SvgCloseModalIcon />}
          footer={null}
        >
          <div className="item-detail__percent-diff-title">
            <SvgWarningIcon />
            <p>{intl.formatMessage({ id: 'item.detail.percentDiff' })}</p>
          </div>
          <div className="item-detail__inputed-button-container">
            <CustomCommonButton
              isCancelButton={true}
              buttonProps={{
                className: 'item-detail__inputed-button-action',
                onClick: () => setIsOpenCheck(false),
                block: true,
              }}
              content={intl.formatMessage({ id: 'common.cancel' })}
            />
            <CustomCommonButton
              isCancelButton={true}
              buttonProps={{
                className: 'item-detail__inputed-button-action',
                type: 'primary',
                onClick: () => submitSize(),
                block: true,
                disabled: uploadRealVolume.isPending || uploadStorageVolume.isPending,
                loading: uploadRealVolume.isPending || uploadStorageVolume.isPending,
              }}
              content={intl.formatMessage({ id: 'common.yes' })}
            />
          </div>
        </Modal>
        <Modal
          title=""
          closable={false}
          open={!!oversizeConfirm}
          className="item-detail__oversize-fee"
          centered={true}
          onCancel={() => setOversizeConfirm(null)}
          footer={null}
        >
          <h6 className="item-detail__oversize-fee-title">
            {intl.formatMessage({ id: 'item.detail.oversizeFee.title' })}
          </h6>
          <p className="item-detail__oversize-fee-message">
            {oversizeConfirm
              ? intl.formatMessage(
                  { id: 'item.detail.oversizeFee.message' },
                  { reason: intl.formatMessage({ id: `item.detail.${oversizeConfirm}` }) },
                )
              : null}
            <br />
            {intl.formatMessage({ id: 'item.detail.oversizeFee.question' })}
          </p>
          <div className="item-detail__oversize-fee-button-container">
            <CustomCommonButton
              isCancelButton={true}
              buttonProps={{
                className: 'item-detail__oversize-fee-button-action',
                onClick: () => setOversizeConfirm(null),
                disabled: addOversizeFee.isPending,
              }}
              content={intl.formatMessage({ id: 'common.cancel' })}
            />
            <CustomCommonButton
              buttonProps={{
                className: 'item-detail__oversize-fee-button-action',
                type: 'primary',
                onClick: handleApproveOversizeFee,
                loading: addOversizeFee.isPending,
              }}
              content={intl.formatMessage({ id: 'item.detail.oversizeFee.approve' })}
            />
          </div>
        </Modal>
        <CustomConfirmModel
          isOpen={!!removePhoto?.open}
          setIsOpen={() => setRemovePhoto(undefined)}
          onFinish={handleRemovePhoto}
          idDataDetail={0}
          titleText=" "
          cancelText={intl.formatMessage({ id: 'common.no' })}
          confirmText={intl.formatMessage({ id: 'common.yes' })}
          className="remove-image-modal"
          messageText={
            <div>
              <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.00015 15.1906C8.12506 15.1906 8.22947 15.1484 8.31338 15.064C8.39777 14.9796 8.43996 14.875 8.43996 14.7501C8.43996 14.6256 8.39777 14.5212 8.31338 14.4368C8.22947 14.3524 8.12506 14.3103 8.00015 14.3103C7.87524 14.3103 7.77083 14.3524 7.68693 14.4368C7.60302 14.5212 7.56082 14.6256 7.56035 14.7501C7.55987 14.8745 7.60206 14.9791 7.68693 15.064C7.77083 15.1484 7.87524 15.1906 8.00015 15.1906ZM7.64259 12.8249H8.35772V8.53414H7.64259V12.8249ZM8.0023 18.4359C7.11267 18.4359 6.27597 18.2671 5.49218 17.9295C4.70888 17.5915 4.02736 17.1329 3.44762 16.5536C2.86789 15.9744 2.40901 15.2936 2.07099 14.5112C1.73297 13.7289 1.56396 12.8924 1.56396 12.0018C1.56396 11.1112 1.73274 10.2745 2.07028 9.4917C2.40782 8.70887 2.86646 8.02735 3.44619 7.44714C4.02593 6.86692 4.70673 6.40805 5.48861 6.07051C6.27049 5.73296 7.10695 5.56395 7.99801 5.56348C8.88906 5.563 9.72577 5.73177 10.5081 6.06979C11.2905 6.40781 11.972 6.86645 12.5527 7.4457C13.1334 8.02496 13.5922 8.70577 13.9293 9.48812C14.2664 10.2705 14.4354 11.1069 14.4363 11.9975C14.4373 12.8881 14.2685 13.7248 13.93 14.5076C13.5915 15.2905 13.1329 15.972 12.5541 16.5522C11.9753 17.1324 11.2945 17.5913 10.5117 17.9288C9.72887 18.2664 8.8924 18.4354 8.0023 18.4359Z"
                  fill="#F43258"
                />
              </svg>
              <span className="font-size-16 color-sub-title m-l-12">
                {intl.formatMessage({ id: 'item.detail.remove.photo' })}
              </span>
            </div>
          }
        />
        <Modal
          title=""
          closable={true}
          open={isOpenNotifyUpload}
          onCancel={() => setIsOpenNotifyUpload(false)}
          className="item-detail__notify-modal"
          centered={true}
          closeIcon={<SvgCloseModalIcon />}
          footer={null}
        >
          <p>開封動画の撮影が必要です</p>
        </Modal>
        <Modal
          title=""
          closable={false}
          open={openSpecialFeeModal}
          onCancel={handleCloseSpecialFeeModal}
          className="item-detail_special-fee-modal"
          centered={true}
          destroyOnClose
          footer={null}
        >
          <p className="item-detail_special-fee-modal_title">手数料追加</p>

          <div className="item-detail_special-fee-modal_field">
            <label>粗利区分</label>
            <Radio.Group
              value={specialFeeForm.isProfit}
              onChange={(e) => setSpecialFeeForm((prev) => ({ ...prev, isProfit: e.target.value }))}
            >
              <Radio value={true}>粗利対象</Radio>
              <Radio value={false}>粗利対象外</Radio>
            </Radio.Group>
          </div>

          <div className="item-detail_special-fee-modal_field">
            <label>
              手数料名<span className="item-detail_special-fee-modal_required">*</span>
            </label>
            <CustomInput
              placeholder="例: 梱包手数料"
              height={44}
              status={specialFeeError.title ? 'error' : undefined}
              value={specialFeeForm.title}
              onChange={(e) => {
                setSpecialFeeForm((prev) => ({ ...prev, title: e.target.value }));
                setSpecialFeeError((prev) => ({ ...prev, title: false }));
              }}
            />
            {specialFeeError.title && (
              <span className="item-detail_special-fee-modal_error">手数料名を入力してください。</span>
            )}
          </div>

          <div className="item-detail_special-fee-modal_field">
            <label>
              金額 ($)<span className="item-detail_special-fee-modal_required">*</span>
            </label>
            <CustomInput
              type="number"
              placeholder="0.00"
              height={44}
              min={0}
              status={specialFeeError.chargeAmount ? 'error' : undefined}
              value={specialFeeForm.chargeAmount}
              onKeyDown={(e) => (['e', 'E', '+', '-'].includes(e.key) ? e.preventDefault() : null)}
              onChange={(e) => {
                setSpecialFeeForm((prev) => ({ ...prev, chargeAmount: e.target.value }));
                setSpecialFeeError((prev) => ({ ...prev, chargeAmount: false }));
              }}
            />
            {specialFeeError.chargeAmount && (
              <span className="item-detail_special-fee-modal_error">金額を入力してください。</span>
            )}
          </div>

          <div className="item-detail_special-fee-modal_footer">
            <CustomCommonButton
              isCancelButton={true}
              buttonProps={{
                className: 'button-small',
                onClick: handleCloseSpecialFeeModal,
              }}
              content={intl.formatMessage({ id: 'common.cancel' })}
            />
            <CustomCommonButton
              buttonProps={{
                className: 'button-small',
                type: 'primary',
                onClick: handleSubmitSpecialFee,
                disabled: addSpecialHandlingFee.isPending,
                loading: addSpecialHandlingFee.isPending,
              }}
              content={intl.formatMessage({ id: 'common.add' })}
            />
          </div>
        </Modal>
        {openModalNoteDelete.isOpen && (
          <ModalConfirm
            isOpen={true}
            handleCancelModal={handleCancelModal}
            handleSubmitDel={handleSubmitDel}
            wrapClassName="modal-confirm-wrap"
          />
        )}
      </div>
    </Spin>
  );
};
export default ItemDetail;
